import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from "react-i18next";
import { DefaultButton, IconButton, PrimaryButton } from '@fluentui/react/lib/Button';
import { Panel, PanelType } from '@fluentui/react/lib/Panel';
import { Card, Col, Row } from 'react-bootstrap';
import moment from 'moment';
import { useGetPartieFormConfig, useGetPolynomyFormConfig } from '../../../../hooks/component/sPay/useOfContractParties';
import { useDispatch, useSelector } from 'react-redux';
import { action_addContractPartieItem, action_addPartiePolinomy, action_updateContractPartieItem, action_updateContractPartieList, action_updateContractPartieSelected, action_updateContractPartieSelectedId, action_updateContractPartieSidePanelIsOpen, action_updateFormConfigPartie, action_updateFormConfigPartieNumber } from '../../../../reducers/actions/PAY/actions';
import { __MessageTypes, enum__ENUM_CLASE_PARTIDA, enum_CONTACTPARTIE_PARTIE_FORM_VIEW, enum_CONTACTPARTIE_POLINOMY_FORM_VIEW, enum_CONTRACT_PARTIE_SIDEPANELS_CONFIG, enum_CONTRACTPARTIE_PARENT_PONINOMY_TYPE, enum_ENUM_CLASES_PARTIDA_TIPO_CLASE } from '../../../../common/Dictionaries';
import { __OBJECT_STRUCTURE_ContractPartie, __OBJECT_STRUCTURE_GetPolynomy } from '../../../../common/ObjectStructures/sKPI';
import { __calculateTotalRestAdjustmentAmount, __onRenderMonthContent, CalendarCustomInput } from '../../../../common/CommonFuctions';
import { Dropdown, Icon } from '@fluentui/react';
import TablePolynomyItem from '../../../../components/Products/sAdjustment/Polynomy/TablePolynomyItem';
import JqxNumberInput from 'jqwidgets-scripts/jqwidgets-react-tsx/jqxnumberinput';
import JqxInput from 'jqwidgets-scripts/jqwidgets-react-tsx/jqxinput';
import CLabel from '../../../../components/Common/CLabel';
import CValidator from '../../../../components/Common/CValidator';
import DatePicker from 'react-datepicker';
import { isNullUndefined, isNullUndefinedOrEmpty, isNullUndefinedOrEmptyOrZero } from '../../../../common/Helpers';
import { isSameNumberInputValue } from '../../../../common/jqxNumberInput';
import SidePanelBaseDateContractPartie from './SidePanelBaseDateContractPartie';
import { showMessage } from '../../../../common/Helpers';
import { deletePolinomio, getListFullPartidasSubPartidasPolinomios, setItemPartida, setItemPolinomio } from '../../../../services/sPay/partie.service';
import TablePolynomyItemNotAdjustment from '../../../../components/Products/sAdjustment/Polynomy/TablePolynomyItemNotAdjustment';
import PropTypes from 'prop-types';
import { isPonderadorSumWithinLimit } from '../../../../common/ponderadores';
import { _handleDeletePolynomyClick } from '../../Events';

import './style.css'
import 'react-datepicker/dist/react-datepicker.css';
import MessageBoxInfoComplex from '../../../../components/Common/Message/MessageBoxInfoComplex';
import i18next from 'i18next';

const SidePanelInsertEditContractPartie = ({elementId, formView}) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const numberValidDecimals = 10;
    const regexCodigoInterno = /^[A-Za-z0-9\-_]{0,50}$/;

    const {
        _contractPresentation: contractPresentation,
        _contractParties: contractParties,
        _contractPartieSelected: contractPartieSelected,
        _contractPartieSidePanelsConfig: contractPartieSidePanelsConfig,
        _contractFormPartieConfig: contractFormPartieConfig,
        _contractFormPolynomyConfig: contractFormPolynomyConfig,
    } = useSelector((state) => state.contractPartiesState);

    const refCodigoInterno = useRef(null);
    const [disableForm, setDisableForm] = useState(false);
    const [firstLoadExecuted, setFirstLoadExecuted] = useState(false);
    const [objContractPartie, setObjContractPartie] = useState(
        formView === enum_CONTACTPARTIE_PARTIE_FORM_VIEW.EDIT ? contractPartieSelected : {
                iteM_PARTIDA: __OBJECT_STRUCTURE_ContractPartie(elementId),
                l_POLINOMIO: [],
                l_SUBPARTIDA: [],
            }
        );
    const [objPolynomy, setObjPolynomy] = useState(__OBJECT_STRUCTURE_GetPolynomy());
    //Usado para obtener el % no reajustable.
    const [totalRestAdjustmentAmount, setTotalRestAdjustmentAmount] = useState(objContractPartie !== null ? __calculateTotalRestAdjustmentAmount(objContractPartie.l_POLINOMIO) : 0);

    //const numberInputRefGastoPrevioBasePartida = useRef(null);
    //const numberInputGastoPrevioReajustePartida = useRef(null);
    //const numberInputGastoPrevioDiftcPartidaMc = useRef(null);
    //const numberInputMontoTotalPartida = useRef(null);
    //const numberInputCantidadTotalServicio = useRef(null);
    //const numberInputCantidadPreviaServicio = useRef(null);
    //const numberInputMontoTotalSumaAlzadaPartida = useRef(null);
    //const numberInputClasePartidaId = useRef(null);
    //const numberInputPrecioUnitarioBasePartida = useRef(null);
    //const numberInputPonderador = useRef(null);
    //const numberInputRefPeriodicidadMeses = useRef(null);

    const [messageConfig, setMessageConfig] = useState({
        message : null,
        messageType : "",
        showMessage : false,
    });

    const [isOpen, setIsOpen] = useState(false);
    const [objEndDateOutOfContract, setObjEndDateOutOfContract] = useState(false);

    

    const [isDialogOpen, setIsDialogOpen] = useState(false);

    const [objIsValidForm, setObjIsValidForm] = useState({
        //Número de Partida.
        //Código de Partida.

        isInValidCodigoPartida                      : false,

        isInValidCodigoInterno                      : false,

        isInValidNombrePartida                      : false,
        canValidateNombrePartida                    : true,

        isInValidClasePartida                       : false,
        canValidateClasePartida                     : true,

        isInValidTipoPartidaId                      : false,
        canValidateTipoPartidaId                    : true,

        isInValidIdMonedaPartida                    : false,
        canValidateIdMonedaPartida                  : true,

        isInValidMesInicioPartida                   : false,
        canValidateMesInicioPartida                 : true,

        isInValidMesTerminoPartida                  : false,
        canValidateMesTerminoPartida                : true,

        isInValidMesPrevio                          : false,
        canValidateMesPrevio                        : true,

        isInValidGastoPrevioBasePartida             : false,
        canValidateGastoPrevioBasePartida           : true,

        isInValidGastoPrevioReajustePartida         : false,
        canValidateGastoPrevioReajustePartida       : true,

        isInValidGastoPrevioDiftcPartidaMc          : false,
        canValidateGastoPrevioDiftcPartidaMc        : true,

        isInvalidMcNombre                           : false,
        canValidateMcNombre                         : true,

        isInValidMontoTotalPartida                  : false,
        canValidateMontoTotalPartida                : false,

        isInValidCantidadPreviaServicio             : false,
        canValidateCantidadPreviaServicio           : true,

        isInValidCantidadTotalServicio              : false,
        canValidateCantidadTotalServicio            : true,

        isInvalidUnidadPartida                      : false,
        canValidateUnidadPartida                    : true,

        isInvalidPrecioUnitarioBasePartida          : false,
        canValidatePrecioUnitarioBasePartida        : true,

        isInvalidMontoTotalSumaAlzadaPartidaPc      : false,
        canValidateMontoTotalSumaAlzadaPartidaPc    : true,
        
        isInvalidMontoTotalSumaAlzadaPartidaPs      : false,
        canValidateMontoTotalSumaAlzadaPartidaPs    : true,

        visible_divInfoAd                           : true,
        visible_pnlPS                               : true,
        visible_divMontoTotal                       : true,
        visible_divMontoTotal_Pc                    : true,
        visible_divMontoTotal_Ps                    : true,
        visible_pnlPSPrecioUnitario                 : true,
    });

    const [objIsValidPolynomyForm, setObjIsValidPolynomyForm] = useState({
        isInvalidPolynomyType      : false,
        isInValidPonderador        : false,

        isInValidFechaBase         : false,
        isInvalidMonthOffset       : false,

        isInValidPeriodicidadMeses : false,
        isInValidPrimerMesReajuste : false,
    });
    
    useGetPartieFormConfig(elementId, contractFormPartieConfig)
    useGetPolynomyFormConfig(contractFormPolynomyConfig)

    const isInvalidForm = () => {
        let isInvalid = false;

        isInvalid = !isInvalid ? isNullUndefinedOrEmpty(objContractPartie.iteM_PARTIDA.codigoPartida) : isInvalid;
        objIsValidForm.isInValidCodigoPartida = isNullUndefinedOrEmpty(objContractPartie.iteM_PARTIDA.codigoPartida);

        //if (!isNullUndefinedOrEmpty(objContractPartie.iteM_PARTIDA.codigoInterno)) {
            objIsValidForm.isInValidCodigoInterno = isNullUndefinedOrEmpty(objContractPartie.iteM_PARTIDA.codigoInterno) ? regexCodigoInterno.test(objContractPartie.iteM_PARTIDA.codigoInterno) : false;
        //}
        //else {
        //    objIsValidForm.isInValidCodigoInterno = true;
        //}

        if (objIsValidForm.canValidateNombrePartida) {
            objIsValidForm.isInValidNombrePartida = isNullUndefinedOrEmpty(objContractPartie.iteM_PARTIDA.nombrePartida);
            isInvalid = !isInvalid ? isNullUndefinedOrEmpty(objContractPartie.iteM_PARTIDA.nombrePartida) : isInvalid;
        }
        else {
            objIsValidForm.isInValidNombrePartida = false
            isInvalid = !isInvalid ? objIsValidForm.isInValidNombrePartida : isInvalid;
        }
        
        if (objIsValidForm.canValidateMcNombre) {
            objIsValidForm.isInvalidMcNombre = isNullUndefinedOrEmpty(objContractPartie.iteM_PARTIDA.idMcContrato);
            isInvalid = !isInvalid ? isNullUndefinedOrEmpty(objContractPartie.iteM_PARTIDA.idMcContrato) : isInvalid;
        }
        else {
            objIsValidForm.isInvalidMcNombre = false
            isInvalid = !isInvalid ? objIsValidForm.isInvalidMcNombre : isInvalid;
        }
        
        if (objIsValidForm.canValidateClasePartida) {
            objIsValidForm.isInValidClasePartida = isNullUndefinedOrEmptyOrZero(objContractPartie.iteM_PARTIDA.clasePartidaId);
            isInvalid = !isInvalid ? isNullUndefinedOrEmptyOrZero(objContractPartie.iteM_PARTIDA.clasePartidaId) : isInvalid;
        }
        else {
            objIsValidForm.isInValidClasePartida = false
            isInvalid = !isInvalid ? objIsValidForm.isInValidClasePartida : isInvalid;
        }
        
        if (objIsValidForm.canValidateTipoPartidaId) {
            objIsValidForm.isInValidTipoPartidaId = isNullUndefinedOrEmptyOrZero(objContractPartie.iteM_PARTIDA.tipoPartidaId);
            isInvalid = !isInvalid ? isNullUndefinedOrEmptyOrZero(objContractPartie.iteM_PARTIDA.tipoPartidaId) : isInvalid;
        }
        else {
            objIsValidForm.isInValidTipoPartidaId = false
            isInvalid = !isInvalid ? objIsValidForm.isInValidTipoPartidaId : isInvalid;
        }
        
        if (objIsValidForm.canValidateIdMonedaPartida) {
            objIsValidForm.isInValidIdMonedaPartida = isNullUndefinedOrEmptyOrZero(objContractPartie.iteM_PARTIDA.idMonedaPartida);
            isInvalid = !isInvalid ? isNullUndefinedOrEmptyOrZero(objContractPartie.iteM_PARTIDA.idMonedaPartida): isInvalid;
        }
        else {
            objIsValidForm.isInValidIdMonedaPartida = false
            isInvalid = !isInvalid ? objIsValidForm.isInValidIdMonedaPartida : isInvalid;
        }
        
        if (objIsValidForm.canValidateMesInicioPartida)  {
            objIsValidForm.isInValidMesInicioPartida  = isNullUndefinedOrEmpty(objContractPartie.iteM_PARTIDA.mesInicioPartida) || objContractPartie.iteM_PARTIDA.mesInicioPartida === "0000/00";
            isInvalid = !isInvalid ? isNullUndefinedOrEmpty(objContractPartie.iteM_PARTIDA.mesInicioPartida) || objContractPartie.iteM_PARTIDA.mesInicioPartida === "0000/00" : isInvalid;
        }
        else {
            objIsValidForm.isInValidMesInicioPartida = false
            isInvalid = !isInvalid ? objIsValidForm.isInValidMesInicioPartida : isInvalid;
        }
        
        if (objIsValidForm.canValidateMesTerminoPartida) {
            const aux_isNullOrEmpty = isNullUndefinedOrEmpty(objContractPartie.iteM_PARTIDA.mesTerminoPartida) || objContractPartie.iteM_PARTIDA.mesTerminoPartida === "0000/00";

            if (aux_isNullOrEmpty) {
                objIsValidForm.isInValidMesTerminoPartida = aux_isNullOrEmpty
                isInvalid = !isInvalid ? isNullUndefinedOrEmpty(objContractPartie.iteM_PARTIDA.mesTerminoPartida) || objContractPartie.iteM_PARTIDA.mesTerminoPartida === "0000/00" : isInvalid;
            }
            else {
                const isLeqThanContractEndDate = moment(contractFormPartieConfig.endDate).toDate() >= moment(objContractPartie.iteM_PARTIDA.mesTerminoPartida).toDate()

                if (!isLeqThanContractEndDate) {
                    setObjEndDateOutOfContract(true);
                }
                else {
                    setObjEndDateOutOfContract(false);
                    objIsValidForm.isInValidMesTerminoPartida = false
                    isInvalid = !isInvalid ? false : isInvalid;
                }
            }
        }
        else {
            objIsValidForm.isInValidMesTerminoPartida = false
            isInvalid = !isInvalid ? objIsValidForm.isInValidMesTerminoPartida : isInvalid;
        }
        
        if (objIsValidForm.canValidateMesPrevio) {
            objIsValidForm.isInValidMesPrevio = isNullUndefinedOrEmpty(objContractPartie.iteM_PARTIDA.mesPrevio) || objContractPartie.iteM_PARTIDA.mesPrevio === "0000/00";
            isInvalid = !isInvalid ? isNullUndefinedOrEmpty(objContractPartie.iteM_PARTIDA.mesPrevio) || objContractPartie.iteM_PARTIDA.mesPrevio === "0000/00" : isInvalid;
        }
        else {
            objIsValidForm.isInValidMesPrevio = false
            isInvalid = !isInvalid ? objIsValidForm.isInValidMesPrevio : isInvalid;
        }

        if (objIsValidForm.canValidateGastoPrevioBasePartida) {
            objIsValidForm.isInValidGastoPrevioBasePartida = isNullUndefinedOrEmpty(objContractPartie.iteM_PARTIDA.gastoPrevioBasePartida);
            isInvalid = !isInvalid ? isNullUndefinedOrEmpty(objContractPartie.iteM_PARTIDA.gastoPrevioBasePartida) : isInvalid;
        }
        else {
            objIsValidForm.isInValidGastoPrevioBasePartida = false
            isInvalid = !isInvalid ? objIsValidForm.isInValidGastoPrevioBasePartida : isInvalid;
        }
        
        if (objIsValidForm.canValidateGastoPrevioReajustePartida) {
            objIsValidForm.isInValidGastoPrevioReajustePartida = isNullUndefinedOrEmpty(objContractPartie.iteM_PARTIDA.gastoPrevioReajustePartida);
            isInvalid = !isInvalid ? isNullUndefinedOrEmpty(objContractPartie.iteM_PARTIDA.gastoPrevioReajustePartida) : isInvalid;
        }
        else {
            objIsValidForm.isInValidGastoPrevioReajustePartida = false
            isInvalid = !isInvalid ? objIsValidForm.isInValidGastoPrevioReajustePartida : isInvalid;
        }
        
        if (objIsValidForm.canValidateGastoPrevioDiftcPartidaMc) {
            objIsValidForm.isInValidGastoPrevioDiftcPartidaMc = isNullUndefinedOrEmptyOrZero(objContractPartie.iteM_PARTIDA.gastoPrevioDiftcPartidaMc);
            isInvalid = !isInvalid ? isNullUndefinedOrEmptyOrZero(objContractPartie.iteM_PARTIDA.gastoPrevioDiftcPartidaMc) : isInvalid;
        }
        else {
            objIsValidForm.isInValidGastoPrevioDiftcPartidaMc = false
            isInvalid = !isInvalid ? objIsValidForm.isInValidGastoPrevioDiftcPartidaMc : isInvalid;
        }
        
        if (objIsValidForm.canValidateMontoTotalPartida) {
            objIsValidForm.isInValidMontoTotalPartida = isNullUndefinedOrEmptyOrZero(objContractPartie.iteM_PARTIDA.montoTotalPartida);
            isInvalid = !isInvalid ? isNullUndefinedOrEmptyOrZero(objContractPartie.iteM_PARTIDA.montoTotalPartida) : isInvalid;
        }
        else {
            objIsValidForm.isInValidMontoTotalPartida = false
            isInvalid = !isInvalid ? objIsValidForm.isInValidMontoTotalPartida : isInvalid;
        }
        
        if (objIsValidForm.canValidateUnidadPartida) {
            objIsValidForm.isInvalidUnidadPartida = isNullUndefinedOrEmptyOrZero(objContractPartie.iteM_PARTIDA.unidadPartidaId);
            isInvalid = !isInvalid ? isNullUndefinedOrEmptyOrZero(objContractPartie.iteM_PARTIDA.unidadPartidaId) : isInvalid;
        }
        else {
            objIsValidForm.isInvalidUnidadPartida = false
            isInvalid = !isInvalid ? objIsValidForm.isInvalidUnidadPartida : isInvalid;
        }
        
        if (objIsValidForm.canValidateCantidadPreviaServicio) {
            objIsValidForm.isInValidCantidadPreviaServicio = isNullUndefinedOrEmpty(objContractPartie.iteM_PARTIDA.cantidadPreviaServicio);
            isInvalid = !isInvalid ? isNullUndefinedOrEmpty(objContractPartie.iteM_PARTIDA.cantidadPreviaServicio) : isInvalid;
        }
        else {
            objIsValidForm.isInValidCantidadPreviaServicio = false
            isInvalid = !isInvalid ? objIsValidForm.isInValidCantidadPreviaServicio : isInvalid;
        }
        
        if (objIsValidForm.canValidateCantidadTotalServicio) {
            objIsValidForm.isInValidCantidadTotalServicio = isNullUndefinedOrEmptyOrZero(objContractPartie.iteM_PARTIDA.cantidadTotalServicio);
            isInvalid = !isInvalid ? isNullUndefinedOrEmptyOrZero(objContractPartie.iteM_PARTIDA.cantidadTotalServicio) : isInvalid; }
        else { 
            objIsValidForm.isInValidCantidadTotalServicio = false 
            isInvalid = !isInvalid ? objIsValidForm.isInValidCantidadTotalServicio : isInvalid;
        }
        
        if (objIsValidForm.canValidatePrecioUnitarioBasePartida) {
            objIsValidForm.isInvalidPrecioUnitarioBasePartida = isNullUndefinedOrEmptyOrZero(objContractPartie.iteM_PARTIDA.precioUnitarioBasePartida);
            isInvalid = !isInvalid ? isNullUndefinedOrEmptyOrZero(objContractPartie.iteM_PARTIDA.precioUnitarioBasePartida) : isInvalid;
        }
        else {
            objIsValidForm.isInvalidPrecioUnitarioBasePartida = false
            isInvalid = !isInvalid ? objIsValidForm.isInvalidPrecioUnitarioBasePartida : isInvalid;
        }
        
        if (objIsValidForm.canValidateMontoTotalSumaAlzadaPartidaPc) {
            objIsValidForm.isInvalidMontoTotalSumaAlzadaPartidaPc = isNullUndefinedOrEmptyOrZero(objContractPartie.iteM_PARTIDA.montoTotalSumaAlzadaPartida);
            isInvalid = !isInvalid ? isNullUndefinedOrEmptyOrZero(objContractPartie.iteM_PARTIDA.montoTotalSumaAlzadaPartida) : isInvalid;
        }
        else {
            objIsValidForm.isInvalidMontoTotalSumaAlzadaPartidaPc = false
            isInvalid = !isInvalid ? objIsValidForm.isInvalidMontoTotalSumaAlzadaPartidaPc : isInvalid;
        }

        if (objIsValidForm.canValidateMontoTotalSumaAlzadaPartidaPs) {
            objIsValidForm.isInvalidMontoTotalSumaAlzadaPartidaPs = isNullUndefinedOrEmptyOrZero(objContractPartie.iteM_PARTIDA.montoTotalSumaAlzadaPartida);
            isInvalid = !isInvalid ? isNullUndefinedOrEmptyOrZero(objContractPartie.iteM_PARTIDA.montoTotalSumaAlzadaPartida) : isInvalid;
        }
        else {
            objIsValidForm.isInvalidMontoTotalSumaAlzadaPartidaPs = false;
            isInvalid = !isInvalid ? objIsValidForm.isInvalidMontoTotalSumaAlzadaPartidaPs : isInvalid;
        }

        setObjIsValidForm(prevState => ({
            ...prevState,
            isInValidCodigoPartida                 : objIsValidForm.isInValidCodigoPartida                ,
            isInValidCodigoInterno                 : objIsValidForm.isInValidCodigoInterno                ,
            isInValidNombrePartida                 : objIsValidForm.isInValidNombrePartida                ,
            isInValidClasePartida                  : objIsValidForm.isInValidClasePartida                 ,
            isInValidTipoPartidaId                 : objIsValidForm.isInValidTipoPartidaId                ,
            isInValidIdMonedaPartida               : objIsValidForm.isInValidIdMonedaPartida              ,
            isInValidMesInicioPartida              : objIsValidForm.isInValidMesInicioPartida             ,
            isInValidMesTerminoPartida             : objIsValidForm.isInValidMesTerminoPartida            ,
            isInValidMesPrevio                     : objIsValidForm.isInValidMesPrevio                    ,
            isInValidGastoPrevioBasePartida        : objIsValidForm.isInValidGastoPrevioBasePartida       ,
            isInValidGastoPrevioReajustePartida    : objIsValidForm.isInValidGastoPrevioReajustePartida   ,
            isInValidGastoPrevioDiftcPartidaMc     : objIsValidForm.isInValidGastoPrevioDiftcPartidaMc    ,
            isInvalidMcNombre                      : objIsValidForm.isInvalidMcNombre                     ,
            isInValidMontoTotalPartida             : objIsValidForm.isInValidMontoTotalPartida            ,
            isInvalidUnidadPartida                 : objIsValidForm.isInvalidUnidadPartida                ,
            isInValidCantidadPreviaServicio        : objIsValidForm.isInValidCantidadPreviaServicio       ,
            isInValidCantidadTotalServicio         : objIsValidForm.isInValidCantidadTotalServicio        ,
            isInvalidPrecioUnitarioBasePartida     : objIsValidForm.isInvalidPrecioUnitarioBasePartida    ,
            isInvalidMontoTotalSumaAlzadaPartidaPc : objIsValidForm.isInvalidMontoTotalSumaAlzadaPartidaPc,
            isInvalidMontoTotalSumaAlzadaPartidaPs : objIsValidForm.isInvalidMontoTotalSumaAlzadaPartidaPs,
        }));

        return isInvalid;
    };

    const isValidPonderator = (list, newVal) => {
        // Los ponderadores pueden ser número o texto («60.00»): se suman como números (ver common/ponderadores.js).
        const ok = isPonderadorSumWithinLimit(list, newVal);

        return ok;
    }

    const isInvalidPolynomyForm = () => {
        let isInvalid = false;

        objIsValidPolynomyForm.isInValidFechaBase = isNullUndefinedOrEmpty(objPolynomy.fechaBase);
        isInvalid = !isInvalid ? objIsValidPolynomyForm.isInValidFechaBase : isInvalid;

        objIsValidPolynomyForm.isInvalidPolynomyType = isNullUndefinedOrEmptyOrZero(objPolynomy.tipoPolinomioId);
        isInvalid = !isInvalid ? objIsValidPolynomyForm.isInvalidPolynomyType : isInvalid;

        objIsValidPolynomyForm.isInValidPonderador = isNullUndefinedOrEmptyOrZero(objPolynomy.ponderador);
        isInvalid = !isInvalid ? objIsValidPolynomyForm.isInValidPonderador : isInvalid;

        objIsValidPolynomyForm.isInvalidMonthOffset = isNullUndefinedOrEmpty(objPolynomy.mesesDesfase);
        isInvalid = !isInvalid ? objIsValidPolynomyForm.isInvalidMonthOffset : isInvalid;

        objIsValidPolynomyForm.isInValidPeriodicidadMeses = isNullUndefinedOrEmptyOrZero(objPolynomy.periodicidadMeses);
        isInvalid = !isInvalid ? objIsValidPolynomyForm.isInValidPeriodicidadMeses : isInvalid;

        objIsValidPolynomyForm.isInValidPrimerMesReajuste = isNullUndefinedOrEmpty(objPolynomy.primerMesReajuste);
        isInvalid = !isInvalid ? objIsValidPolynomyForm.isInValidPrimerMesReajuste : isInvalid;

        setObjIsValidPolynomyForm(prevState => ({
            ...prevState,
            isInValidFechaBase          : objIsValidPolynomyForm.isInValidFechaBase          ,
            isInvalidPolynomyType       : objIsValidPolynomyForm.isInvalidPolynomyType       ,
            isInValidPonderador         : objIsValidPolynomyForm.isInValidPonderador         ,
            isInvalidMonthOffset        : objIsValidPolynomyForm.isInvalidMonthOffset        ,
            isInValidPeriodicidadMeses  : objIsValidPolynomyForm.isInValidPeriodicidadMeses  ,
            isInValidPrimerMesReajuste  : objIsValidPolynomyForm.isInValidPrimerMesReajuste  ,
        }));

        return isInvalid;
    };

    const handleOpenSubPartiePanel = async () => {
        dispatch(action_updateContractPartieSelected(objContractPartie));
        dispatch(action_updateContractPartieSidePanelIsOpen(enum_CONTRACT_PARTIE_SIDEPANELS_CONFIG.IS_OPEN_SUBPARTIE_INSERT, true));
        dispatch(action_updateContractPartieSidePanelIsOpen(enum_CONTRACT_PARTIE_SIDEPANELS_CONFIG.IS_OPEN_PARTIE_INSERT, false));
    }
        
    const handleOpenPartiePanel = async () => {
        setObjContractPartie(
            formView === enum_CONTACTPARTIE_PARTIE_FORM_VIEW.EDIT ? contractPartieSelected : {
                    iteM_PARTIDA: __OBJECT_STRUCTURE_ContractPartie(elementId),
                    l_POLINOMIO: [],
                    l_SUBPARTIDA: [],
                }
        )

        showMessage(setMessageConfig, false, null, "")
        setDisableForm(false);
    }

    const handleSavePartie = async () => {
        setDisableForm(true);

        if (!isInvalidForm()) {
            const newobj = preparePartieToSave()
            if (isValidPonderator(objContractPartie.l_POLINOMIO, 0)) {
                if (regexCodigoInterno.test(newobj.codigoInterno) === true) {
                    await setItemPartida(newobj).then(async (response) => {
                        setObjIsValidForm(prevState => ({ ...prevState, ["isInValidCodigoInterno"]: false }));
                        
                        if (response.data.succeeded) {
                            if (response.data.data.result) {
                                if (response.data.data.l_messages.length > 0) {
                                    let aux_contractPartie = {...objContractPartie};
                                    aux_contractPartie.iteM_PARTIDA.id = response.data.data.id;
                                    setObjContractPartie(aux_contractPartie);

                                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, response.data.data.l_messages.map(x => `${x}<br>` ))
                                    setDisableForm(false);
                                }
                                else {
                                    const aux_objContractPartie = {...objContractPartie};
                                    aux_objContractPartie.iteM_PARTIDA.id = response.data.data.id;
                                    setObjContractPartie(aux_objContractPartie)
                                    
                                    if (formView === enum_CONTACTPARTIE_PARTIE_FORM_VIEW.INSERT) {
                                        await getListFullPartidasSubPartidasPolinomios(elementId).then((serviceResponse) => {
                                            if (serviceResponse.data.succeeded) {
                                                const responseContractParties = serviceResponse.data.data;
                            
                                                dispatch(action_updateContractPartieList(responseContractParties));
                                                showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-partiesaved'))
                                            }
                                            else {
                                                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                                                setDisableForm(false);
                                            }
                                        }).catch((ex) => {
                                            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                                            setDisableForm(false);
                                        });

                                        dispatch(action_updateFormConfigPartieNumber(contractFormPartieConfig.nro_ccorrelativo + 1))
                                    }
                                    else if (formView === enum_CONTACTPARTIE_PARTIE_FORM_VIEW.EDIT) {
                                        await getListFullPartidasSubPartidasPolinomios(elementId).then((serviceResponse) => {
                                            if (serviceResponse.data.succeeded) {
                                                const responseContractParties = serviceResponse.data.data;
                            
                                                dispatch(action_updateContractPartieList(responseContractParties));
                                                showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-partiesaved'))
                                            }
                                            else {
                                                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                                                setDisableForm(false);
                                            }
                                        }).catch((ex) => {
                                            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                                            setDisableForm(false);
                                        });
                                    }
                                }
                            }
                            else {
                                if (response.data.data.l_messages.length > 0) {
                                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, response.data.data.l_messages.map(x => `${x}<br>` ))
                                }
                                else {
                                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('Se ha producido un problema al crear la partida.'))
                                }

                                setDisableForm(false);
                            }
                        }
                        else {
                            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('Se ha producido un problema al crear la partida.'))
                            setDisableForm(false);
                        }
                    }).catch((ex) => {
                        showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                        setDisableForm(false);
                    });
                }
                else {
                    setDisableForm(false);
                    setObjIsValidForm(prevState => ({ ...prevState, ["isInValidCodigoInterno"]: true }));
                }
            }
            else {
                setDisableForm(false);
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-maxponderatorerror'))
            }
        }
        else {
            setDisableForm(false);
        }
    };

    const handleSavePolynomy = async () => {
        const newobj = preparePolynomyToSave()
        if (!isInvalidPolynomyForm()) {
            if (isValidPonderator(objContractPartie.l_POLINOMIO, newobj.ponderador)) {
                await setItemPolinomio(newobj).then((response) => {
                    if (response.data.succeeded) {
                        if (response.data.data.result) {
                            if (response.data.data.l_messages.length > 0) {
                                showMessage(setMessageConfig, true, __MessageTypes.ERROR, response.data.data.l_messages.map(x => `${x}<br>` ))
                            }
                            else {
                                showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-polynomysaved'))
                                newobj.id = response.data.data.id;
                                dispatch(action_addPartiePolinomy(objContractPartie.iteM_PARTIDA.id, newobj));
                                setObjPolynomy(prevState => ({
                                    ...prevState,
                                    id: null,
                                    tipoPolinomioId: null,
                                    tipoPolinomioTitle: null,
                                    ponderador: null,
                                    fechaBase: null,
                                    valorBase: null,
                                    mesesDesfase: null,
                                    periodicidadMeses: null,
                                    primerMesReajuste: null,
                                }))

                                setTotalRestAdjustmentAmount(totalRestAdjustmentAmount - newobj.ponderador)
                            }
                        }
                        else {
                            if (response.data.data.l_messages.length > 0) {
                                showMessage(setMessageConfig, true, __MessageTypes.ERROR, response.data.data.l_messages.map(x => `${x}<br>` ))
                            }
                            else {
                                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-polynomysavederror'))
                            }
                        }
                    }
                    else {
                        showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-polynomysavederror'))
                    }
                }).catch((ex) => {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                });
            }
            else {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-maxponderatorerror'))
            }
        }
    };

    const preparePartieToSave = () => {
        let newobj = __OBJECT_STRUCTURE_ContractPartie(elementId);

        newobj.id = objContractPartie.iteM_PARTIDA.id;
        newobj.elementId = elementId;
        newobj.codigoContrato = contractPresentation.item_contrato.contractCode;
        newobj.nroPartida = formView === enum_CONTACTPARTIE_PARTIE_FORM_VIEW.INSERT ? contractFormPartieConfig.nro_ccorrelativo : objContractPartie.iteM_PARTIDA.nroPartida
        newobj.codigoPartida = formView === enum_CONTACTPARTIE_PARTIE_FORM_VIEW.EDIT ? objContractPartie.iteM_PARTIDA.codigoPartida : objContractPartie.iteM_PARTIDA.codigoPartida;
        
        let codigoInternoControlValue = null
        if (refCodigoInterno.current?.val) {
            codigoInternoControlValue = refCodigoInterno.current.val();
        } else if (refCodigoInterno.current?.getOptions) {
            codigoInternoControlValue = refCodigoInterno.current.getOptions("value");
        }

        if (objContractPartie.iteM_PARTIDA.codigoInterno === codigoInternoControlValue) {
            newobj.codigoInterno = objContractPartie.iteM_PARTIDA.codigoInterno;
        }
        else {
            newobj.codigoInterno = !isNullUndefined(codigoInternoControlValue) ? codigoInternoControlValue : '';
        }
        
        newobj.nombrePartida = objContractPartie.iteM_PARTIDA.nombrePartida;
        newobj.clasePartidaId = objContractPartie.iteM_PARTIDA.clasePartidaId;
        newobj.tipoPartidaId = objContractPartie.iteM_PARTIDA.tipoPartidaId;
        newobj.idMcContrato = objContractPartie.iteM_PARTIDA.idMcContrato;
        newobj.mcNombre = objContractPartie.iteM_PARTIDA.mcNombre;

        newobj.mesInicioPartida = objContractPartie.iteM_PARTIDA.mesInicioPartida;
        newobj.mesTerminoPartida = objContractPartie.iteM_PARTIDA.mesTerminoPartida;

        newobj.mesPrevio = isNullUndefinedOrEmpty(objContractPartie.iteM_PARTIDA.mesPrevio) ? "0000/00" : objContractPartie.iteM_PARTIDA.mesPrevio;

        newobj.montoTotalPartida = objContractPartie.iteM_PARTIDA.montoTotalPartida;
        
        newobj.idMonedaPartida = objContractPartie.iteM_PARTIDA.idMonedaPartida;
        newobj.monedaPartida = objContractPartie.iteM_PARTIDA.monedaPartida;

        newobj.gastoPrevioBasePartida = objContractPartie.iteM_PARTIDA.gastoPrevioBasePartida;
        newobj.gastoPrevioReajustePartida = objContractPartie.iteM_PARTIDA.gastoPrevioReajustePartida;
        newobj.gastoPrevioDiftcPartidaMc = objContractPartie.iteM_PARTIDA.gastoPrevioDiftcPartidaMc;

        const tipoPartidaSelected = contractFormPartieConfig.l_CLASE.find(x => x.id === objContractPartie.iteM_PARTIDA.clasePartidaId).tipoPartida;

        if (tipoPartidaSelected === enum_ENUM_CLASES_PARTIDA_TIPO_CLASE.SERVICIO)
        {
            newobj.unidadPartidaId = objContractPartie.iteM_PARTIDA.unidadPartidaId;
            newobj.cantidadPreviaServicio = objContractPartie.iteM_PARTIDA.cantidadPreviaServicio;
            newobj.cantidadTotalServicio = objContractPartie.iteM_PARTIDA.cantidadTotalServicio;

            if (objContractPartie.iteM_PARTIDA.clasePartidaId === enum__ENUM_CLASE_PARTIDA.PSP_SUMA_ALZADA)
            {
                newobj.montoTotalSumaAlzadaPartida = objContractPartie.iteM_PARTIDA.montoTotalSumaAlzadaPartida;
            }

            if (objContractPartie.iteM_PARTIDA.clasePartidaId === enum__ENUM_CLASE_PARTIDA.PSP_PRECIO_UNITARIO)
            {
                newobj.precioUnitarioBasePartida = objContractPartie.iteM_PARTIDA.precioUnitarioBasePartida;
            }
        }
        else
        {
            newobj.montoTotalSumaAlzadaPartida = newobj.clasePartidaId === enum__ENUM_CLASE_PARTIDA.PCI_SUMA_ALZADA ? objContractPartie.iteM_PARTIDA.montoTotalSumaAlzadaPartida : 0;
            newobj.unidadPartidaId = null;
        }

        return newobj;
    };

    const preparePolynomyToSave = () => {
        let newobj = {
            id: isNullUndefinedOrEmpty(objPolynomy.id) ? 0 : objPolynomy.id,
            partidaId: objContractPartie.iteM_PARTIDA.id,
            subpartidaId: null,
            fechaBase: !isNullUndefinedOrEmpty(objPolynomy.fechaBase) ? moment(objPolynomy.fechaBase, 'DD/MM/YYYY') : null,
            mesesDesfase: objPolynomy.mesesDesfase,
            periodicidadMeses: objPolynomy.periodicidadMeses,
            ponderador: objPolynomy.ponderador,
            primerMesReajuste: objPolynomy.primerMesReajuste,
            tipoPolinomioId: objPolynomy.tipoPolinomioId,
            tipoPolinomioTitle: objPolynomy.tipoPolinomioTitle,
            valorBase: objPolynomy.valorBase,
        }

        return newobj;
    };

    const onDismissPanel = () => {
        dispatch(action_updateContractPartieSelectedId(null))
        dispatch(action_updateContractPartieSelected(null))

        if (formView === enum_CONTACTPARTIE_PARTIE_FORM_VIEW.INSERT) {
            dispatch(action_updateContractPartieSidePanelIsOpen(enum_CONTRACT_PARTIE_SIDEPANELS_CONFIG.IS_OPEN_PARTIE_INSERT, false))
        }
        else if (formView === enum_CONTACTPARTIE_PARTIE_FORM_VIEW.EDIT) {
            dispatch(action_updateContractPartieSidePanelIsOpen(enum_CONTRACT_PARTIE_SIDEPANELS_CONFIG.IS_OPEN_PARTIE_EDIT, false))
        }
    };

    const onClosePanel = () => {
        onDismissPanel();
    };

    const onClean = () => {
        setObjContractPartie(prevState => (formView === enum_CONTACTPARTIE_PARTIE_FORM_VIEW.EDIT ? contractPartieSelected : {
            iteM_PARTIDA: __OBJECT_STRUCTURE_ContractPartie(elementId),
            l_POLINOMIO: [],
            l_SUBPARTIDA: [],
        }));
    };
    
    const onRenderFooterContent = () => {
        return  <Row>
                    <Col xl={12}>
                        <MessageBoxInfoComplex
                            inputParam_Message={ messageConfig.message }
                            inputParam_Display={ messageConfig.showMessage }
                            inputParam_MessageType={ messageConfig.messageType }
                            inputParam_SetterMessage={ setMessageConfig }
                            inputParam_TranslateText={true}
                            inputParam_ShowClose={true}
                        /> 
                    </Col>
                    <Col xl={12}>
                        {
                            !disableForm &&
                            <>
                                <PrimaryButton className='mx-1' onClick={ handleSavePartie }>{ t('data-lang-btn-save') }</PrimaryButton>
                            </>
                        }
                        {
                            disableForm &&
                            <>
                                <PrimaryButton className='mx-1' onClick={ handleOpenPartiePanel }>{ t('data-lang-btn-createpartie') }</PrimaryButton>
                                {
                                    (objContractPartie.iteM_PARTIDA.clasePartidaId === enum__ENUM_CLASE_PARTIDA.PCI_CONSUMO_RECURSOS || objContractPartie.iteM_PARTIDA.clasePartidaId === enum__ENUM_CLASE_PARTIDA.PSP_CONSUMO_RECURSOS) &&
                                    <PrimaryButton className='mx-1' onClick={ handleOpenSubPartiePanel }>{ t('data-lang-btn-createsubpartie') }</PrimaryButton>
                                }
                            </>
                        }
                        <DefaultButton className='mx-1' onClick={ onClean }>{ t('data-lang-btn-clean') }</DefaultButton>
                        <DefaultButton className='mx-1' onClick={ onClosePanel }>{ t('data-lang-btn-close') }</DefaultButton>
                    </Col>
                </Row>
    };

    const onChangeObjPartieString = (event, fieldName, isInvalidPropertyField) => {
        // El campo numérico vuelve a avisar «change» cada vez que React lo redibuja, aunque el valor sea el mismo.
        // Si no cambió, no se toca el estado: hacerlo provoca un ciclo infinito (React error 185).
        if (isSameNumberInputValue(objContractPartie.iteM_PARTIDA[fieldName], event.args.value)) {
            return;
        }

        commonObjPartieInputSetterValue(event.args.value, fieldName, isInvalidPropertyField)
    };

    const onChangeObjPartieTextInputString = (event, fieldName, isInvalidPropertyField) => {
        if (fieldName === 'codigoInterno') {
            if (!isNullUndefined(event.currentTarget.value)) {
                if (regexCodigoInterno.test(event.currentTarget.value) === true) {
                    commonObjPartieInputSetterValue(event.currentTarget.value, fieldName, isInvalidPropertyField)
                }
                else {
                    setObjContractPartie(prevState => ({
                        ...prevState,
                        iteM_PARTIDA: {
                            ...prevState.iteM_PARTIDA,
                            [fieldName]: event.currentTarget.value,
                        }
                    }));
                    setObjIsValidForm(prevState => ({ ...prevState, [isInvalidPropertyField]: true }));
                }
            }
            else {
                commonObjPartieInputSetterValue('', fieldName, isInvalidPropertyField)
            }
        }
        else {
            commonObjPartieInputSetterValue(event.currentTarget.value, fieldName, isInvalidPropertyField)
        }
    };

    const commonObjPartieInputSetterValue = (value, fieldName, isInvalidPropertyField) => {
        let isInValidValue = isNullUndefinedOrEmpty(value);

        if (fieldName === 'gastoPrevioBasePartida') {
            if (value === 0 || value === '0') {
                isInValidValue = false;
            }
        }
        else if (fieldName === 'codigoInterno') {
            if (!isNullUndefinedOrEmpty(value)) {
                if (regexCodigoInterno.test(value) === true) {
                    isInValidValue = false;
                }
            }
            else {
                isInValidValue = false;
            }
        }

        objContractPartie.iteM_PARTIDA[fieldName] = value;

        setObjContractPartie(prevState => ({
            ...prevState,
            iteM_PARTIDA: {
                ...prevState.iteM_PARTIDA,
                [fieldName]: objContractPartie.iteM_PARTIDA[fieldName],
            }
        }));

        setObjIsValidForm(prevState => ({ ...prevState, [isInvalidPropertyField]: isInValidValue }));
    }

    const onChangeObjPolynomyString = (event, fieldName) => {
        commonObjPolynomyInputSetterValue(event.args.value, fieldName)
    };

    const onChangeObjPolynomyTextInputString = (event, fieldName) => {
        commonObjPolynomyInputSetterValue(event.currentTarget.value, fieldName)
    };

    const commonObjPolynomyInputSetterValue = (value, fieldName) => {
        objPolynomy[fieldName] = value;
        setObjPolynomy(objPolynomy)
    }

    const handleSelectClass = (ev, item) => {
        const isInValidValue = isNullUndefinedOrEmpty(item.key) || item.key === 0;
        const currentItem = contractFormPartieConfig.l_CLASE.find(x => x.id === item.key);

        if (!isNullUndefinedOrEmpty(currentItem)) {
            objContractPartie.iteM_PARTIDA.clasePartidaTitle = currentItem.title;
            objContractPartie.iteM_PARTIDA.clasePartidaId = currentItem.id;
        }
        else {
            objContractPartie.iteM_PARTIDA.clasePartidaTitle = '';
            objContractPartie.iteM_PARTIDA.clasePartidaId = 0;
        }

        setObjContractPartie(prevState => ({
            ...prevState,
            iteM_PARTIDA: {
                ...prevState.iteM_PARTIDA,
                clasePartidaTitle: objContractPartie.iteM_PARTIDA.clasePartidaTitle,
                clasePartidaId: objContractPartie.iteM_PARTIDA.clasePartidaId
            }
        }));

        setObjIsValidForm(prevState => ({ ...prevState, isInValidClasePartida: isInValidValue }));

        Vista();
    };

    const handleSelectType = (ev, item) => {
        const isInValidValue = isNullUndefinedOrEmpty(item.key) || item.key === 0;
        const currentItem = contractFormPartieConfig.l_TIPO.find(x => x.id === item.key);

        if (!isNullUndefinedOrEmpty(currentItem)) {
            objContractPartie.iteM_PARTIDA.tipoPartidaTitle = currentItem.title;
            objContractPartie.iteM_PARTIDA.tipoPartidaId = currentItem.id;
        }
        else {
            objContractPartie.iteM_PARTIDA.tipoPartidaTitle = '';
            objContractPartie.iteM_PARTIDA.tipoPartidaId = 0;
        }

        setObjContractPartie(prevState => ({
            ...prevState,
            iteM_PARTIDA: {
                ...prevState.iteM_PARTIDA,
                tipoPartidaTitle: objContractPartie.iteM_PARTIDA.tipoPartidaTitle,
                tipoPartidaId: objContractPartie.iteM_PARTIDA.tipoPartidaId
            }
        }));
        setObjIsValidForm(prevState => ({ ...prevState, isInValidTipoPartidaId: isInValidValue }));
    };

    const handleSelectCurrency = (ev, item) => {
        const isInValidValue = isNullUndefinedOrEmpty(item.key) || item.key === 0;
        const currentItem = contractFormPartieConfig.l_MONEDA.find(x => x.id === item.key);
        if (!isNullUndefinedOrEmpty(currentItem)) {
            objContractPartie.iteM_PARTIDA.monedaPartida = currentItem.code;
            objContractPartie.iteM_PARTIDA.idMonedaPartida = currentItem.id;
        }
        else {
            objContractPartie.iteM_PARTIDA.monedaPartida = '';
            objContractPartie.iteM_PARTIDA.idMonedaPartida = 0;
        }

        setObjContractPartie(prevState => ({
            ...prevState,
            iteM_PARTIDA: {
                ...prevState.iteM_PARTIDA,
                monedaPartida: objContractPartie.iteM_PARTIDA.monedaPartida,
                idMonedaPartida: objContractPartie.iteM_PARTIDA.idMonedaPartida
            }
        }));

        Establecer_Difenrecia_TC();

        setObjIsValidForm(prevState => ({ ...prevState, isInValidIdMonedaPartida: isInValidValue }));
    };

    const handleSelectMcNombre = (ev, item) => {
        //Esta linea es como Legacy
        //const isInValidValue = isNullUndefinedOrEmpty(item.key) || item.key === 0;

        //Esta para que grabe por ahora
        const isInValidValue = isNullUndefinedOrEmpty(item.key);

        const currentItem = contractFormPartieConfig.l_NRO_MC.find(x => x.id === item.key);

        /*if (currentItem !== null && objContractPartie.iteM_PARTIDA.id === 0)
        {
            var item_mc = contractFormPartieConfig.l_NRO_MC.find(p => p.id == item.key);
            if (objContractPartie.iteM_PARTIDA.id == 0 && !isNullUndefinedOrEmpty(item_mc))
            {
                if (item_mc.date !== null) {
                    objContractPartie.iteM_PARTIDA.mesInicioPartida = moment(item_mc.date).format('YYYY/MM');
                }
            }
        }
        else
        { 
            objContractPartie.iteM_PARTIDA.mesInicioPartida = moment(contractFormPartieConfig.l_NRO_MC.startDate).format('YYYY/MM');
        }*/
        
        ////////////////////

        if (currentItem.id > 0) {
            var item_mc = contractFormPartieConfig.l_NRO_MC.find(p => p.id == item.key);
            if (objContractPartie.iteM_PARTIDA.id == 0 && !isNullUndefinedOrEmpty(item_mc))
            {
                if (item_mc.date !== null) {
                    objContractPartie.iteM_PARTIDA.mesInicioPartida = moment(item_mc.date).format('YYYY/MM');
                }
            }
        }
        else {
            objContractPartie.iteM_PARTIDA.mesInicioPartida = moment(contractFormPartieConfig.startDate).format('YYYY/MM');
        }

        ////////////////////


        if (!isNullUndefinedOrEmpty(currentItem)) {
            objContractPartie.iteM_PARTIDA.mcNombre = currentItem.title;
            objContractPartie.iteM_PARTIDA.idMcContrato = currentItem.id;
        }
        else {
            objContractPartie.iteM_PARTIDA.mcNombre = '';
            objContractPartie.iteM_PARTIDA.idMcContrato = 0;
        }
        
        setObjContractPartie(prevState => ({
            ...prevState,
            iteM_PARTIDA: {
                ...prevState.iteM_PARTIDA,
                mcNombre: objContractPartie.iteM_PARTIDA.mcNombre,
                idMcContrato: objContractPartie.iteM_PARTIDA.idMcContrato,
                mesInicioPartida: objContractPartie.iteM_PARTIDA.mesInicioPartida,
            }
        }));
        setObjIsValidForm(prevState => ({ ...prevState, isInvalidMcNombre: isInValidValue }));
    };

    const handleSelectServiceUnit = (ev, item) => {
        const isInValidValue = isNullUndefinedOrEmpty(item.key) || item.key === 0;
        const currentItem = contractFormPartieConfig.l_UNIDAD.find(x => x.id === item.key);
        if (!isNullUndefinedOrEmpty(currentItem)) {
            objContractPartie.iteM_PARTIDA.unidadPartidaTitle = currentItem.title;
            objContractPartie.iteM_PARTIDA.unidadPartidaId = currentItem.id;
        }
        else {
            objContractPartie.iteM_PARTIDA.unidadPartidaTitle = '';
            objContractPartie.iteM_PARTIDA.unidadPartidaId = 0;
        }
        
        setObjContractPartie(prevState => ({
            ...prevState,
            iteM_PARTIDA: {
                ...prevState.iteM_PARTIDA,
                unidadPartidaTitle: objContractPartie.iteM_PARTIDA.unidadPartidaTitle,
                unidadPartidaId: objContractPartie.iteM_PARTIDA.unidadPartidaId,
            }
        }));
        setObjIsValidForm(prevState => ({ ...prevState, isInvalidUnidadPartida: isInValidValue }));
    };

    const handleSelectPolynomyType = (ev, item) => {
        const currentItem = contractFormPolynomyConfig.l_TIPO_POLINOMIO.find(x => x.id === item.key);

        setObjPolynomy(prevState => ({
            ...prevState,
            tipoPolinomioId: currentItem.id,
            tipoPolinomioTitle: currentItem.title
        }));
    };

    const handleSelectMonthDiff = (ev, item) => {
        const currentItem = contractFormPolynomyConfig.l_MESES_DESFASE.find(x => x === item.key);

        setObjPolynomy(prevState => ({
            ...prevState,
            mesesDesfase: currentItem
        }));
    };

    const handleDateChange = (value, controlName) => {
        const isC3C5 = (
            objContractPartie.iteM_PARTIDA.clasePartidaId === enum__ENUM_CLASE_PARTIDA.PCI_CONSUMO_RECURSOS ||
            objContractPartie.iteM_PARTIDA.clasePartidaId === enum__ENUM_CLASE_PARTIDA.PSP_CONSUMO_RECURSOS ||
            objContractPartie.iteM_PARTIDA.clasePartidaId === 0
        );

        const isLeqThanContractEndDate = moment(contractFormPartieConfig.endDate).toDate() >= moment(value).toDate()

        if (!isLeqThanContractEndDate && controlName === "mesTerminoPartida") {
            setObjEndDateOutOfContract(true);
            setObjContractPartie(prevState => ({
                ...prevState,
                iteM_PARTIDA: {
                    ...prevState.iteM_PARTIDA,
                    [controlName]: null,
                }
            }));
            return;
        }
        else {
            setObjEndDateOutOfContract(false);
        }

        let isInValidValue = isNullUndefinedOrEmpty(value) || value === "0000/00";

        objContractPartie.iteM_PARTIDA[controlName] = moment(value).format('YYYY/MM');

        setObjContractPartie(prevState => ({
            ...prevState,
            iteM_PARTIDA: {
                ...prevState.iteM_PARTIDA,
                [controlName]: objContractPartie.iteM_PARTIDA[controlName],
            }
        }));

        switch (controlName) {
            case "mesInicioPartida":
                setObjIsValidForm(prevState => ({ ...prevState, isInValidMesInicioPartida: isInValidValue }));
                break;
            case "mesTerminoPartida":
                setObjIsValidForm(prevState => ({ ...prevState, isInValidMesTerminoPartida: isInValidValue }));
                break;
            case "mesPrevio":
                setObjIsValidForm(prevState => ({
                    ...prevState,
                    isInValidMesPrevio: isInValidValue,
                    canValidateGastoPrevioBasePartida: isC3C5 ? false : true,
                    canValidateGastoPrevioReajustePartida: isC3C5 ? false : true,
                }));
                break;
            default:
                break;
        }
    };

    const clearMesPrevio = () => {
        setObjContractPartie(prevState => ({
            ...prevState,
            iteM_PARTIDA: {
                ...prevState.iteM_PARTIDA,
                mesPrevio: null,
                gastoPrevioDiftcPartidaMc: 0,
                gastoPrevioBasePartida: 0,
                gastoPrevioReajustePartida: 0
            }
        }));

        setObjIsValidForm(prevState => ({
            ...prevState,
            isInValidMesPrevio: false,
            canValidateGastoPrevioBasePartida: false,
            canValidateGastoPrevioReajustePartida: false,
            canValidateGastoPrevioDiftcPartidaMc: false,
        }));
    };
    const openMesPrevio = () => {
        setIsOpen(true)
    }

    const closeMesPrevio = () => {
        setIsOpen(false)
    }

    const handlePolynomyDateChange = (value, controlName) => {
        let isInValidValue = isNullUndefinedOrEmpty(value) || value === "0000/00";
        objPolynomy[controlName] = moment(value).format('YYYY/MM');
        setObjPolynomy(objPolynomy)
        setObjIsValidPolynomyForm(prevState => ({ ...prevState, isInValidMesPrevio: isInValidValue }));
    };

    const handleSetPolynomyBaseDate = (objectBaseDate) => {
        setObjPolynomy(prevState => ({
            ...prevState,
            valorBase: objectBaseDate.valor,
            fechaBase: objectBaseDate.fecha
        }));

        setIsDialogOpen(false);
    };

    const handleDeletePolynomyClick = async (tableItemId, parentId, _contractParties) =>{
        await deletePolinomio(tableItemId).then((response) => {
            if (response.data.succeeded) {
                let currentValue = 0;
                const aux_contractParties = _contractParties.map(obj => {
                    if (obj.iteM_PARTIDA.id === parentId) {
                        currentValue = obj.l_POLINOMIO.find(item => item.id === tableItemId).ponderador;
                        return {
                            ...obj,
                            l_POLINOMIO: obj.l_POLINOMIO.filter(item => item.id !== tableItemId)
                        };
                    }
                    return obj;
                });

                dispatch(action_updateContractPartieList(aux_contractParties));

                try {
                    setObjContractPartie(aux_contractParties.find(x => x.iteM_PARTIDA.id === parentId))
                } catch (error) {
                    
                }

                setTotalRestAdjustmentAmount(parseFloat(totalRestAdjustmentAmount) + parseFloat(currentValue))
            }
            else {

            }
        }).catch(() => {

        });
    }

    const onSelectBaseDateDialog = () => {
        if (!isNullUndefinedOrEmpty(objPolynomy.tipoPolinomioId)) {
            setIsDialogOpen(true);
        }
        else {
            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-selectpolynomytype'))
        }
    };

    //Mismo nombre que en Legacy
    const Establecer_Visualizacion_Combo = () => {
        const isC3C5 = (
            objContractPartie.iteM_PARTIDA.clasePartidaId === enum__ENUM_CLASE_PARTIDA.PCI_CONSUMO_RECURSOS ||
            objContractPartie.iteM_PARTIDA.clasePartidaId === enum__ENUM_CLASE_PARTIDA.PSP_CONSUMO_RECURSOS ||
            objContractPartie.iteM_PARTIDA.clasePartidaId === 0
        )

        let mesPrevioValue = objContractPartie.iteM_PARTIDA.mesPrevio ?? "";
        mesPrevioValue = isNullUndefinedOrEmpty(mesPrevioValue) ? "0000/00" : mesPrevioValue;
        const flag = mesPrevioValue === "0000/00";

        const gastoPrevioBaseReadOnly = ( contractFormPartieConfig.tiene_ep ? true : flag ? true : false);
        objContractPartie.iteM_PARTIDA.gastoPrevioBasePartida = gastoPrevioBaseReadOnly ? 0 : objContractPartie.iteM_PARTIDA.gastoPrevioBasePartida
        objIsValidForm.canValidateGastoPrevioBasePartida = isC3C5 ? false : !gastoPrevioBaseReadOnly;

        const gastoPrevioReajusteReadOnly = ( contractFormPartieConfig.tiene_ep ? true : flag ? true : false);
        objContractPartie.iteM_PARTIDA.gastoPrevioReajustePartida = gastoPrevioReajusteReadOnly ? 0 : objContractPartie.iteM_PARTIDA.gastoPrevioReajustePartida
        objIsValidForm.canValidateGastoPrevioReajustePartida = isC3C5 ? false : !gastoPrevioReajusteReadOnly;
        
        const clase_id = objContractPartie.iteM_PARTIDA.clasePartidaId;

        if (clase_id === enum__ENUM_CLASE_PARTIDA.PSP_SUMA_ALZADA | clase_id === enum__ENUM_CLASE_PARTIDA.PSP_PRECIO_UNITARIO | clase_id === enum__ENUM_CLASE_PARTIDA.PSP_CONSUMO_RECURSOS)
        {
            if (objContractPartie.iteM_PARTIDA.cantidadPreviaServicio !== null)
            {
                const cantidadPreviaServicioReadOnly = ( contractFormPartieConfig.tiene_ep ? true : flag ? true : false);
                objContractPartie.iteM_PARTIDA.cantidadPreviaServicio = cantidadPreviaServicioReadOnly ? 0 : objContractPartie.iteM_PARTIDA.cantidadPreviaServicio
                objIsValidForm.canValidateCantidadPreviaServicio = !cantidadPreviaServicioReadOnly;
            } 
        }
        else {
            objIsValidForm.canValidateCantidadPreviaServicio = false;
        }

        if (clase_id === enum__ENUM_CLASE_PARTIDA.PSP_CONSUMO_RECURSOS | clase_id === enum__ENUM_CLASE_PARTIDA.PCI_CONSUMO_RECURSOS)
        {
            objIsValidForm.canValidateGastoPrevioReajustePartida = false;
            objIsValidForm.canValidateGastoPrevioBasePartida = false;
        }

        setObjContractPartie(prevState => ({
            ...prevState,
            iteM_PARTIDA: {
                ...prevState.iteM_PARTIDA,
                gastoPrevioBasePartida: objContractPartie.iteM_PARTIDA.gastoPrevioBasePartida,
                gastoPrevioReajustePartida: objContractPartie.iteM_PARTIDA.gastoPrevioReajustePartida,
                cantidadPreviaServicio: objContractPartie.iteM_PARTIDA.cantidadPreviaServicio,
            }
        }));

        setObjIsValidForm(prevState => ({
            ...prevState,
            canValidateGastoPrevioReajustePartida: objIsValidForm.canValidateGastoPrevioReajustePartida,
            canValidateGastoPrevioBasePartida: objIsValidForm.canValidateGastoPrevioBasePartida,
            canValidateCantidadPreviaServicio: objIsValidForm.canValidateCantidadPreviaServicio,
            canValidateMontoTotalPartida: objIsValidForm.canValidateMontoTotalPartida
        }));
    };

    //Mismo nombre que en Legacy
    const Establecer_Difenrecia_TC = () => {
        const monedaPartida_id = objContractPartie.iteM_PARTIDA.idMonedaPartida;
        const monedaContrato_id = formView === enum_CONTACTPARTIE_PARTIE_FORM_VIEW.INSERT ? contractPresentation.item_contrato.currencyId : objContractPartie.iteM_PARTIDA.idMonedaContrato;
        let flagMoneda = true;
        
        //console.log('Flag => ' + flagMoneda);
        if (monedaPartida_id > 0)
        {
            //console.log('Flag0 => ' + flagMoneda);
            flagMoneda = monedaContrato_id !== monedaPartida_id ? false : true;
            //console.log('Flag1 => ' + flagMoneda);
        }

        //console.log('Flag2 => ' + flagMoneda);
        //console.log('monedaContrato_id !== monedaPartida_id ? false : true => ' + (monedaContrato_id !== monedaPartida_id ? false : true))

        if (!flagMoneda)
        {
            let mesPrevioValue = objContractPartie.iteM_PARTIDA.mesPrevio ?? "";
            mesPrevioValue = isNullUndefinedOrEmpty(mesPrevioValue) ? "0000/00" : mesPrevioValue;
            flagMoneda = mesPrevioValue === "0000/00";
        }

        const gastoPrevioDiftcPartidaMcReadOnly = contractFormPartieConfig.tiene_ep ? true : flagMoneda;

        objContractPartie.iteM_PARTIDA.gastoPrevioDiftcPartidaMc = gastoPrevioDiftcPartidaMcReadOnly ? 0 : objContractPartie.iteM_PARTIDA.gastoPrevioDiftcPartidaMc
        objIsValidForm.canValidateGastoPrevioDiftcPartidaMc = !gastoPrevioDiftcPartidaMcReadOnly;

        const clase_id = objContractPartie.iteM_PARTIDA.claseTipoPartidaId;
        if (clase_id === enum__ENUM_CLASE_PARTIDA.PSP_CONSUMO_RECURSOS | clase_id === enum__ENUM_CLASE_PARTIDA.PCI_CONSUMO_RECURSOS)
        {
            objIsValidForm.canValidateGastoPrevioDiftcPartidaMc = false;
        }

        setObjContractPartie(prevState => ({
            ...prevState,
            iteM_PARTIDA: {
                ...prevState.iteM_PARTIDA,
                gastoPrevioDiftcPartidaMc: objContractPartie.iteM_PARTIDA.gastoPrevioDiftcPartidaMc,
            }
        }));

        setObjIsValidForm(prevState => ({
            ...prevState,
            canValidateGastoPrevioDiftcPartidaMc: objIsValidForm.canValidateGastoPrevioDiftcPartidaMc,
        }));
    };

    //Mismo nombre que en Legacy
    const Vista = () => {
        if (formView === enum_CONTACTPARTIE_PARTIE_FORM_VIEW.INSERT)
        {
            //document.getElementById('divInfoAd').style.display = "none";
            objIsValidForm.visible_divInfoAd = false;
            objIsValidForm.canValidateMesPrevio = false;
        }

        if (formView === enum_CONTACTPARTIE_PARTIE_FORM_VIEW.EDIT)
        {
            if (contractFormPartieConfig.tiene_ep)
            {
                objIsValidForm.canValidateNombrePartida = false;
                objIsValidForm.canValidateClasePartida = false;
                objIsValidForm.canValidateTipoPartidaId = false;
                objIsValidForm.canValidateMesInicioPartida = false;
                objIsValidForm.canValidateMesTerminoPartida = true;
                objIsValidForm.canValidateMesPrevio = false;
                objIsValidForm.canValidateIdMonedaPartida = false;
                objIsValidForm.canValidateGastoPrevioBasePartida = false;
                objIsValidForm.canValidateUnidadPartida = false;
                objIsValidForm.canValidateCantidadPreviaServicio = false;
            }
            else {
                objIsValidForm.canValidateMesPrevio = false;
            }
        }

        if (formView === enum_CONTACTPARTIE_PARTIE_FORM_VIEW.INSERT || formView == enum_CONTACTPARTIE_PARTIE_FORM_VIEW.EDIT)
        {
            Establecer_Visualizacion_Combo();
            Establecer_Difenrecia_TC();
    
            let parseClasePartidaOk = false;

            try { parseInt(objContractPartie.iteM_PARTIDA.clasePartidaId); parseClasePartidaOk = true; } catch (error) { parseClasePartidaOk = false }

            if (parseClasePartidaOk & objContractPartie.iteM_PARTIDA.clasePartidaId > 0)
            {
                const tipoPartidaSelected = contractFormPartieConfig.l_CLASE.find(x => x.id === objContractPartie.iteM_PARTIDA.clasePartidaId).tipoPartida;

                objIsValidForm.visible_divInfoAd = objContractPartie.iteM_PARTIDA.clasePartidaId === enum__ENUM_CLASE_PARTIDA.PCI_CONSUMO_RECURSOS ? false : true;
    
                objIsValidForm.visible_pnlPS = tipoPartidaSelected === enum_ENUM_CLASES_PARTIDA_TIPO_CLASE.SERVICIO ? true : false;
                
                objIsValidForm.canValidateUnidadPartida = tipoPartidaSelected === enum_ENUM_CLASES_PARTIDA_TIPO_CLASE.SERVICIO ? true : false;
                objIsValidForm.canValidateCantidadTotalServicio = tipoPartidaSelected === enum_ENUM_CLASES_PARTIDA_TIPO_CLASE.SERVICIO ? true : false;
        
                objIsValidForm.visible_divMontoTotal = objContractPartie.iteM_PARTIDA.clasePartidaId === enum__ENUM_CLASE_PARTIDA.PCI_SUMA_ALZADA | objContractPartie.iteM_PARTIDA.clasePartidaId === enum__ENUM_CLASE_PARTIDA.PSP_SUMA_ALZADA ? true : false;
                objIsValidForm.visible_divMontoTotal_Ps = objContractPartie.iteM_PARTIDA.clasePartidaId === enum__ENUM_CLASE_PARTIDA.PSP_SUMA_ALZADA ? true : false;
                objIsValidForm.visible_divMontoTotal_Pc = objContractPartie.iteM_PARTIDA.clasePartidaId === enum__ENUM_CLASE_PARTIDA.PCI_SUMA_ALZADA ? true : false;
                
                objIsValidForm.canValidateMontoTotalSumaAlzadaPartidaPs = objContractPartie.iteM_PARTIDA.clasePartidaId === enum__ENUM_CLASE_PARTIDA.PSP_SUMA_ALZADA ? true : false;
                objIsValidForm.canValidateMontoTotalSumaAlzadaPartidaPc = objContractPartie.iteM_PARTIDA.clasePartidaId === enum__ENUM_CLASE_PARTIDA.PCI_SUMA_ALZADA ? true : false;
    
                objIsValidForm.visible_pnlPSPrecioUnitario = objContractPartie.iteM_PARTIDA.clasePartidaId === enum__ENUM_CLASE_PARTIDA.PSP_PRECIO_UNITARIO ? true : false;
                objIsValidForm.canValidatePrecioUnitarioBasePartida = objContractPartie.iteM_PARTIDA.clasePartidaId === enum__ENUM_CLASE_PARTIDA.PSP_PRECIO_UNITARIO ? true : false;
        
                if (objContractPartie.iteM_PARTIDA.clasePartidaId === enum__ENUM_CLASE_PARTIDA.PSP_CONSUMO_RECURSOS || objContractPartie.iteM_PARTIDA.clasePartidaId === enum__ENUM_CLASE_PARTIDA.PCI_CONSUMO_RECURSOS)
                {
                    objIsValidForm.canValidateGastoPrevioBasePartida = false;
                    objIsValidForm.canValidateGastoPrevioReajustePartida = false;
                    objIsValidForm.canValidateGastoPrevioDiftcPartidaMc = false;
                }
            }

            if (contractFormPartieConfig.tiene_ep)
            {
                objIsValidForm.canValidateMesPrevio = false;
            }
        }

        setObjIsValidForm(prevState => ({
            ...prevState,
            visible_divInfoAd: objIsValidForm.visible_divInfoAd,
            visible_pnlPS: objIsValidForm.visible_pnlPS,
            canValidateUnidadPartida: objIsValidForm.canValidateUnidadPartida,
            canValidateCantidadTotalServicio: objIsValidForm.canValidateCantidadTotalServicio,
            visible_divMontoTotal: objIsValidForm.visible_divMontoTotal,
            visible_divMontoTotal_Ps: objIsValidForm.visible_divMontoTotal_Ps,
            visible_divMontoTotal_Pc: objIsValidForm.visible_divMontoTotal_Pc,
            canValidateMontoTotalSumaAlzadaPartidaPs: objIsValidForm.canValidateMontoTotalSumaAlzadaPartidaPs,
            canValidateMontoTotalSumaAlzadaPartidaPc: objIsValidForm.canValidateMontoTotalSumaAlzadaPartidaPc,
            visible_pnlPSPrecioUnitario: objIsValidForm.visible_pnlPSPrecioUnitario,
            canValidatePrecioUnitarioBasePartida: objIsValidForm.canValidatePrecioUnitarioBasePartida,
            canValidateGastoPrevioBasePartida: objIsValidForm.canValidateGastoPrevioBasePartida,
            canValidateGastoPrevioReajustePartida: objIsValidForm.canValidateGastoPrevioReajustePartida,
            canValidateGastoPrevioDiftcPartidaMc: objIsValidForm.canValidateGastoPrevioDiftcPartidaMc,
            canValidateMesPrevio: objIsValidForm.canValidateMesPrevio,
            canValidateCantidadPreviaServicio: objIsValidForm.canValidateCantidadPreviaServicio,
            canValidateMontoTotalPartida: objIsValidForm.canValidateMontoTotalPartida
        }));

        GenerateSelectContent();
    };

    //Mismo nombre que en Legacy
    const Fill = () => {

        if (isNullUndefinedOrEmpty(contractFormPartieConfig.l_CLASE.find(x => x.id === 0))) {
            contractFormPartieConfig.l_CLASE.unshift({id: 0, title: t('data-lang-lbl-select'), tipoClase: null, tipoPartida: null})
        }
        
        if (isNullUndefinedOrEmpty(contractFormPartieConfig.l_MONEDA.find(x => x.id === 0))) {
            contractFormPartieConfig.l_MONEDA.unshift({id: 0, name: t('data-lang-lbl-select'), code: null, type: null})
        }
        
        if (isNullUndefinedOrEmpty(contractFormPartieConfig.l_TIPO.find(x => x.id === 0))) {
            contractFormPartieConfig.l_TIPO.unshift({id: 0, title: t('data-lang-lbl-select'), tipoClase: null, tipoPartida: null})
        }
        
        if (isNullUndefinedOrEmpty(contractFormPartieConfig.l_UNIDAD.find(x => x.id === 0))) {
            contractFormPartieConfig.l_UNIDAD.unshift({id: 0, title: t('data-lang-lbl-select')})
        }
        
        if (isNullUndefinedOrEmpty(contractFormPartieConfig.l_NRO_MC.find(x => x.id === null))) {
            contractFormPartieConfig.l_NRO_MC.unshift({id: null, name: t('data-lang-lbl-select'), type: null, date: null, code: null})
        }
        
        dispatch(action_updateFormConfigPartie(contractFormPartieConfig))

        if (formView == enum_CONTACTPARTIE_PARTIE_FORM_VIEW.INSERT)
        {
            objContractPartie.iteM_PARTIDA.mesInicioPartida = moment(contractFormPartieConfig.startDate).format('YYYY/MM');
            objContractPartie.iteM_PARTIDA.mesTerminoPartida = moment(contractFormPartieConfig.endDate).format('YYYY/MM');
            objContractPartie.iteM_PARTIDA.nroPartida = getPartieNumber();
            objContractPartie.iteM_PARTIDA.mcNombre = "null";
            objContractPartie.iteM_PARTIDA.idMcContrato = null;


            setObjContractPartie(prevState => ({
                ...prevState,
                iteM_PARTIDA: {
                    ...prevState.iteM_PARTIDA,
                    mesInicioPartida: objContractPartie.iteM_PARTIDA.mesInicioPartida,
                    mesTerminoPartida: objContractPartie.iteM_PARTIDA.mesTerminoPartida,
                    nroPartida: objContractPartie.iteM_PARTIDA.nroPartida,
                    mcNombre: objContractPartie.iteM_PARTIDA.mcNombre,
                    idMcContrato: objContractPartie.iteM_PARTIDA.idMcContrato,
                }
            }));
        }
    }

    //Mismo nombre que en Legacy
    const GenerateSelectContent = () => {
        const itemMcFound = contractFormPartieConfig.l_NRO_MC.find(x => x.id === objContractPartie.iteM_PARTIDA.idMcContrato);
        if (itemMcFound === undefined) {
            objContractPartie.iteM_PARTIDA.idMcContrato = null
            objContractPartie.iteM_PARTIDA.mcNombre = "null";
        }

        setObjContractPartie(prevState => ({
            ...prevState,
            iteM_PARTIDA: {
                ...prevState.iteM_PARTIDA,
                idMcContrato: objContractPartie.iteM_PARTIDA.idMcContrato,
                mcNombre: objContractPartie.iteM_PARTIDA.mcNombre,
            }
        }));
    }

    const getPartieNumber = () => {
        if (formView === enum_CONTACTPARTIE_PARTIE_FORM_VIEW.INSERT) {
            if (contractParties.length === 0) {
                return 1;
            }

            return Math.max(...contractParties.map(obj => obj.iteM_PARTIDA.nroPartida)) + 1;
        }
        else if (formView === enum_CONTACTPARTIE_PARTIE_FORM_VIEW.EDIT) {
            return objContractPartie.iteM_PARTIDA.nroPartida;
        }
        else {
            return 0;
        }
    };

    //Funciona como un page load.
    useEffect(() => {
        if (firstLoadExecuted === false && contractFormPartieConfig !== null && objContractPartie !== null) {

            Fill();

            Vista();

            setFirstLoadExecuted(true);
        }
    }, [firstLoadExecuted, contractFormPartieConfig, objContractPartie]);

    useEffect(() => {
        const handleWheel = (event) => {
            event.preventDefault();
        };
    
        const numberInputs = document.querySelectorAll('.jqx-numberinput');
    
        numberInputs.forEach((input) => {
            input.addEventListener('wheel', handleWheel);
        });
    
        return () => {
            numberInputs.forEach((input) => {
                input.removeEventListener('wheel', handleWheel);
            });
        };
    }, []);

    useEffect(() => {
        const handleWheel = (event) => {
            event.preventDefault();
        };
    
        const numberInputs = document.querySelectorAll('.jqx-input-content');
    
        numberInputs.forEach((input) => {
            input.addEventListener('wheel', handleWheel);
        });
    
        return () => {
            numberInputs.forEach((input) => {
                input.removeEventListener('wheel', handleWheel);
            });
        };
    }, []);

    return (
        <div>
            <Panel
                isOpen={ contractPartieSidePanelsConfig.isPanelEditPartieOpen || contractPartieSidePanelsConfig.isPanelInsertPartieOpen }
                isBlocking={true}
                onDismiss={ onDismissPanel }
                headerText={ t('data-lang-boxname-partieform') }
                closeButtonAriaLabel={ t('data-lang-btn-close') }
                isFooterAtBottom={ true }
                onRenderFooterContent={ onRenderFooterContent }
                type={PanelType.custom}
                customWidth="950px"
            >
                {
                    contractFormPartieConfig && contractFormPolynomyConfig && objContractPartie && objContractPartie.iteM_PARTIDA &&
                    <fieldset disabled={disableForm}>
                        <div className='pt-4'>
                            <div style={{borderBottom: "1px solid #999"}}><h5>{ t('data-lang-lbl-contractpartie-partieinfo') }</h5></div>
                            <Row className='pt-1'>
                                {
                                    formView !== enum_CONTACTPARTIE_PARTIE_FORM_VIEW.INSERT &&
                                    <Col xs={12} xl={6}>
                                        <CLabel labelText={ t('data-lang-lbl-contractpartie-partienumber') } labelValue={ formView === enum_CONTACTPARTIE_PARTIE_FORM_VIEW.INSERT ? contractFormPartieConfig.nro_ccorrelativo : objContractPartie.iteM_PARTIDA.nroPartida } />
                                    </Col>
                                }
                                <Col xs={12} xl={6} className="mt-1">
                                    <CLabel labelText={ t('data-lang-lbl-contractpartie-partiecode') } />
                                    <JqxInput
                                        height={25}
                                        width={"100%"}
                                        value={objContractPartie.iteM_PARTIDA.codigoPartida}
                                        onChange={(e) => onChangeObjPartieTextInputString(e, 'codigoPartida', 'isInValidCodigoPartida')}
                                    />
                                    <div id='rqPartidaCodigo'>
                                        <CValidator isInValid={objIsValidForm.isInValidCodigoPartida} inValidText={t('data-lang-msg-required')} /> 
                                    </div>
                                </Col>
                            </Row>
                            <Row className='pt-1'>
                                <Col xs={12} xl={6} className="mt-1">
                                    <CLabel labelText={ t('data-lang-lbl-contractpartie-partiename') } /><br/>
                                    <JqxInput
                                        height={25}
                                        width={"100%"}
                                        value={objContractPartie.iteM_PARTIDA.nombrePartida}
                                        disabled={!objIsValidForm.canValidateNombrePartida}
                                        onChange={(e) => onChangeObjPartieTextInputString(e, 'nombrePartida', 'isInValidNombrePartida')}
                                    />
                                    {
                                        objIsValidForm.canValidateNombrePartida &&
                                        <div id='rqPartidaNombre'>
                                            <CValidator isInValid={objIsValidForm.isInValidNombrePartida} inValidText={t('data-lang-msg-required')} /> 
                                        </div>
                                    }
                                </Col>
                                <Col xs={12} xl={6} className="mt-1">
                                    <CLabel labelText={ t('data-lang-lbl-contractpartie-partieclass') } />
                                    <Dropdown
                                        placeholder={t('data-lang-lbl-contractpartie-partieclass')}
                                        options={contractFormPartieConfig.l_CLASE !== null ? contractFormPartieConfig.l_CLASE.map(item => { return  { key: item.id, text: item.title } }) : []}
                                        selectedKey={objContractPartie.iteM_PARTIDA.clasePartidaId}
                                        onChange={handleSelectClass}
                                        checkable
                                        disabled={!objIsValidForm.canValidateClasePartida}
                                        styles={ {title: { height: "27px" }} }
                                        className="mb-1"
                                    />
                                    {
                                        objIsValidForm.canValidateClasePartida &&
                                        <div id='rqfClasePartida'>
                                            <CValidator isInValid={objIsValidForm.isInValidClasePartida} inValidText={t('data-lang-msg-required')} /> 
                                        </div>
                                    }
                                </Col>
                            </Row>
                            <Row className='pt-1'>
                                <Col xs={12} xl={6} className="mt-1">
                                    <CLabel labelText={ t('data-lang-lbl-contractpartie-partietype') } />
                                    <Dropdown
                                        placeholder={t('data-lang-lbl-contractpartie-partietype')}
                                        options={contractFormPartieConfig.l_TIPO !== null ? contractFormPartieConfig.l_TIPO.map(item => { return  { key: item.id, text: item.title } }) : []}
                                        selectedKey={objContractPartie.iteM_PARTIDA.tipoPartidaId}
                                        onChange={handleSelectType}
                                        checkable
                                        disabled={!objIsValidForm.canValidateTipoPartidaId}
                                        styles={ {title: { height: "27px" }} }
                                        className="mb-1"
                                    />
                                    {
                                        objIsValidForm.canValidateTipoPartidaId &&
                                        <div id='rqfTipoPartida'>
                                            <CValidator isInValid={objIsValidForm.isInValidTipoPartidaId} inValidText={t('data-lang-msg-required')} /> 
                                        </div>
                                    }
                                </Col>
                                <Col xs={12} xl={6} className="mt-1">
                                    <CLabel labelText={ t('data-lang-lbl-contractpartie-partiecurrency') } />
                                    <Dropdown
                                        placeholder={t('data-lang-lbl-contractpartie-partiecurrency')}
                                        options={contractFormPartieConfig.l_MONEDA !== null ? contractFormPartieConfig.l_MONEDA.map(item => { return  { key: item.id, text: item.code } }) : []}
                                        selectedKey={objContractPartie.iteM_PARTIDA.idMonedaPartida}
                                        onChange={handleSelectCurrency}
                                        checkable
                                        disabled={!objIsValidForm.canValidateIdMonedaPartida}
                                        styles={ {title: { height: "27px" }} }
                                        className="mb-1"
                                    />
                                    {
                                        objIsValidForm.canValidateIdMonedaPartida &&
                                        <div id='rfvddlMonedaPartida'>
                                            <CValidator isInValid={objIsValidForm.isInValidIdMonedaPartida} inValidText={t('data-lang-msg-required')} /> 
                                        </div>
                                    }
                                </Col>
                            </Row>
                            <Row className='pt-1'>
                                <Col xs={12} xl={6} className="mt-1">
                                    <CLabel labelText={ t('data-lang-lbl-contractpartie-partiestartmonth') } /><br/>
                                    <DatePicker
                                        selected={ objContractPartie.iteM_PARTIDA.mesInicioPartida && (objContractPartie.iteM_PARTIDA.mesInicioPartida !== "0000/00" ? moment(objContractPartie.iteM_PARTIDA.mesInicioPartida, "YYYY/MM").toDate() : null) } 
                                        onChange={(date) => handleDateChange(date, 'mesInicioPartida')}
                                        height={25}
                                        width={"100%"}
                                        dateFormat="yyyy/MM"
                                        showMonthYearPicker
                                        showFullMonthYearPicker
                                        disabled={!objIsValidForm.canValidateMesInicioPartida}
                                        renderMonthContent={__onRenderMonthContent}
                                        placeholderText={ t('data-lang-lbl-contractpartie-partiestartmonth') } 
                                        className="form-control"
                                        customInput={ <CalendarCustomInput icon={<Icon iconName='Calendar' />} /> }
                                    />
                                    {
                                        objIsValidForm.canValidateMesInicioPartida &&
                                        <div id=''>
                                            <CValidator isInValid={objIsValidForm.isInValidMesInicioPartida} inValidText={t('data-lang-msg-required')} /> 
                                        </div>
                                    }  
                                </Col>
                                <Col xs={12} xl={6} className="mt-1">
                                    <CLabel labelText={ t('data-lang-lbl-contractpartie-partieendmonth') } /><br/>
                                    <DatePicker
                                        selected={ objContractPartie.iteM_PARTIDA.mesTerminoPartida && (objContractPartie.iteM_PARTIDA.mesTerminoPartida !== "0000/00" ? moment(objContractPartie.iteM_PARTIDA.mesTerminoPartida, "YYYY/MM").toDate() : null) } 
                                        onChange={(date) => handleDateChange(date, 'mesTerminoPartida')}
                                        height={25}
                                        width={"100%"}
                                        dateFormat="yyyy/MM"
                                        showMonthYearPicker
                                        showFullMonthYearPicker
                                        disabled={!objIsValidForm.canValidateMesTerminoPartida}
                                        renderMonthContent={__onRenderMonthContent}
                                        placeholderText={ t('data-lang-lbl-contractpartie-partieendmonth') } 
                                        className="form-control"
                                        customInput={ <CalendarCustomInput icon={<Icon iconName='Calendar' />} /> }
                                    />
                                    {
                                        objIsValidForm.canValidateMesTerminoPartida &&
                                        <div id=''>
                                            <CValidator isInValid={objIsValidForm.isInValidMesTerminoPartida} inValidText={t('data-lang-msg-required')} /> 
                                            {
                                                objEndDateOutOfContract &&
                                                <CValidator isInValid={true} inValidText={t('data-lang-msg-enddateoutofextension')} /> 
                                            }
                                        </div>
                                    }
                                </Col>
                            </Row>
                            <Row className='pt-1'>
                                <Col xs={12} xl={6} className="mt-1">
                                    <CLabel labelText={ t('data-lang-lbl-contractpartie-partieprevmonth') } /><br/>
                                    <div className='d-flex' style={{width: "fit-content"}} >
                                        <DatePicker
                                            selected={ objContractPartie.iteM_PARTIDA.mesPrevio && (objContractPartie.iteM_PARTIDA.mesPrevio !== "0000/00" ? moment(objContractPartie.iteM_PARTIDA.mesPrevio, "YYYY/MM").toDate() : null) } 
                                            onChange={(date) => handleDateChange(date, 'mesPrevio')}
                                            height={25}
                                            width={"100%"}
                                            dateFormat="yyyy/MM"
                                            filterDate={(date) => {
                                                const today = new Date();
                                                return (
                                                    date.getFullYear() < today.getFullYear() ||
                                                    (date.getFullYear() === today.getFullYear() && date.getMonth() < today.getMonth())
                                                );
                                            }}
                                            showMonthYearPicker
                                            showFullMonthYearPicker
                                            renderMonthContent={__onRenderMonthContent}
                                            placeholderText={ t('data-lang-lbl-contractpartie-partieprevmonth') } 
                                            className="form-control"
                                            customInput={ <CalendarCustomInput icon={<Icon iconName='Calendar' />} /> }
                                        />
                                        <IconButton className='ms-1' iconProps={{iconName: "Clear"}} onClick={clearMesPrevio} />
                                    </div>
                                </Col>
                                {

                                }
                                <Col xs={12} xl={6} className="mt-1">
                                    <CLabel labelText={ t('data-lang-lbl-contractpartie-partieprevmonthexpensebase') } />
                                    <JqxNumberInput
                                        max={999999999999999}
                                        maxLength="25"
                                        inputMode="advanced"
                                        height={25}
                                        width={"100%"}
                                        decimalDigits={numberValidDecimals}
                                        digits={19}
                                        symbolPosition={'right'}
                                        value={objContractPartie.iteM_PARTIDA.gastoPrevioBasePartida}
                                        //groupSeparator= '.'
                                        //decimalSeparator= ','
                                        disabled={
                                            (
                                                objContractPartie.iteM_PARTIDA.clasePartidaId === enum__ENUM_CLASE_PARTIDA.PCI_CONSUMO_RECURSOS ||
                                                objContractPartie.iteM_PARTIDA.clasePartidaId === enum__ENUM_CLASE_PARTIDA.PSP_CONSUMO_RECURSOS ||
                                                objContractPartie.iteM_PARTIDA.clasePartidaId === 0
                                            ) ? true :
                                            !objIsValidForm.canValidateGastoPrevioBasePartida
                                        }
                                        onChange={(e) => onChangeObjPartieString(e, 'gastoPrevioBasePartida', 'isInValidGastoPrevioBasePartida')}
                                    />
                                    {
                                        objIsValidForm.canValidateGastoPrevioBasePartida &&
                                        <div id='rfvtxtGastoPrevioBase'>
                                            <CValidator isInValid={objIsValidForm.isInValidGastoPrevioBasePartida} inValidText={t('data-lang-msg-required')} /> 
                                        </div>
                                    }
                                </Col>
                            </Row>
                            <Row className='pt-1'>
                                <Col xs={12} xl={6} className="mt-1">
                                    <CLabel labelText={ t('data-lang-lbl-contractpartie-partieprevexpensemonthadjunst') } />
                                    <JqxNumberInput
                                        max={999999999999}
                                        maxLength="25"
                                        inputMode="advanced"
                                        height={25}
                                        width={"100%"}
                                        decimalDigits={numberValidDecimals}
                                        digits={19}
                                        symbolPosition={'right'}
                                        value={objContractPartie.iteM_PARTIDA.gastoPrevioReajustePartida}
                                        //groupSeparator= '.'
                                        //decimalSeparator= ','                                        
                                        disabled={
                                            (
                                                objContractPartie.iteM_PARTIDA.clasePartidaId === enum__ENUM_CLASE_PARTIDA.PCI_CONSUMO_RECURSOS ||
                                                objContractPartie.iteM_PARTIDA.clasePartidaId === enum__ENUM_CLASE_PARTIDA.PSP_CONSUMO_RECURSOS ||
                                                objContractPartie.iteM_PARTIDA.clasePartidaId === 0
                                            ) ? true :
                                            !objIsValidForm.canValidateGastoPrevioReajustePartida
                                        }
                                        onChange={(e) => onChangeObjPartieString(e, 'gastoPrevioReajustePartida', 'isInValidGastoPrevioReajustePartida')}
                                    />
                                    {
                                        objIsValidForm.canValidateGastoPrevioReajustePartida &&
                                        <div id='rfvtxtGastoPrevioReajuste'>
                                            <CValidator isInValid={objIsValidForm.isInValidGastoPrevioReajustePartida} inValidText={t('data-lang-msg-required')} /> 
                                        </div>
                                    }
                                </Col>
                                <Col xs={12} xl={6} className="mt-1">
                                    <CLabel labelText={ t('data-lang-lbl-contractpartie-partieprevexpensedifference') } />
                                    <JqxNumberInput
                                        max={999999999999999}
                                        maxLength="25"
                                        inputMode="advanced"
                                        height={25}
                                        width={"100%"}
                                        decimalDigits={numberValidDecimals}
                                        digits={19}
                                        symbolPosition={'right'}
                                        //value={(objContractPartie.iteM_PARTIDA.gastoPrevioDiftcPartidaMc)}
                                        value={parseFloat(objContractPartie.iteM_PARTIDA.gastoPrevioDiftcPartidaMc.toFixed(2)).toLocaleString(i18next.language)}
                                        groupSeparator= '.'
                                        decimalSeparator= ','
                                        disabled={
                                            (
                                                objContractPartie.iteM_PARTIDA.clasePartidaId === enum__ENUM_CLASE_PARTIDA.PCI_CONSUMO_RECURSOS ||
                                                objContractPartie.iteM_PARTIDA.clasePartidaId === enum__ENUM_CLASE_PARTIDA.PSP_CONSUMO_RECURSOS ||
                                                objContractPartie.iteM_PARTIDA.clasePartidaId === 0
                                            ) ? true :
                                            !objIsValidForm.canValidateGastoPrevioDiftcPartidaMc
                                        }
                                        onChange={(e) => onChangeObjPartieString(e, 'gastoPrevioDiftcPartidaMc', 'isInValidGastoPrevioDiftcPartidaMc')}
                                    />
                                    {
                                        objIsValidForm.canValidateGastoPrevioDiftcPartidaMc &&
                                        <div id='rfvtxtGastoPrevioDifTC'>
                                            <CValidator isInValid={objIsValidForm.isInValidGastoPrevioDiftcPartidaMc} inValidText={t('data-lang-msg-required')} /> 
                                        </div>
                                    }
                                </Col>
                            </Row>
                            <Row className='pt-1'>
                                <Col xs={12} xl={6} className="mt-1">
                                    <CLabel labelText={ t('data-lang-lbl-contractpartie-contractmodificationnumber') } />
                                        <Dropdown
                                            placeholder={t('data-lang-lbl-contractpartie-contractmodificationnumber')}
                                            options={contractFormPartieConfig.l_NRO_MC !== null ? contractFormPartieConfig.l_NRO_MC.map(item => { return  { key: item.id, text: item.name } }) : []}
                                            selectedKey={objContractPartie.iteM_PARTIDA.idMcContrato}
                                            onChange={handleSelectMcNombre}
                                            checkable
                                            styles={ {title: { height: "27px" }} }
                                            className="mb-1"
                                        />
                                        {
                                            objIsValidForm.canValidateMcNombre &&
                                            <div id='rfvddlNRO_Modificacion_C'>
                                                <CValidator isInValid={objIsValidForm.isInvalidMcNombre} inValidText={t('data-lang-msg-required')} /> 
                                            </div>
                                        }
                                </Col>
                                <Col xs={12} xl={6} className="mt-1">
                                    <CLabel labelText={ t('data-lang-lbl-contractpartie-partietotalmonth') } />
                                    <JqxNumberInput
                                        max={999999999999999}
                                        maxLength="25"
                                        inputMode="advanced"
                                        height={25}
                                        width={"100%"}
                                        decimalDigits={numberValidDecimals}
                                        digits={19}
                                        symbolPosition={'right'}
                                        value={objContractPartie.iteM_PARTIDA.montoTotalPartida}
                                        //groupSeparator= '.'
                                        //decimalSeparator= ','
                                        disabled={!objIsValidForm.canValidateMontoTotalPartida}
                                        onChange={(e) => onChangeObjPartieString(e, 'montoTotalPartida', 'isInValidMontoTotalPartida')}
                                    />
                                    {
                                        objIsValidForm.canValidateMontoTotalPartida &&
                                        <div>
                                            <CValidator isInValid={objIsValidForm.isInValidMontoTotalPartida} inValidText={t('data-lang-msg-required')} /> 
                                        </div>
                                    }
                                </Col>
                            </Row>
                        </div>
                        {
                            objIsValidForm.visible_divInfoAd &&
                            <div id='divInfoAd' className='pt-4'>
                            <div style={{borderBottom: "1px solid #999"}}><h5>{ t('data-lang-lbl-contractpartie-aditionalpartieinfo') }</h5></div>
                            {
                                objIsValidForm.visible_pnlPS &&
                                <div id='pnlPS'>
                                    <Row className='pt-1'>
                                        <Col xs={12} xl={6}>
                                            <CLabel labelText={ t('data-lang-lbl-contractpartie-serviceunit') } />
                                            <Dropdown
                                                placeholder={t('data-lang-lbl-contractpartie-serviceunit')}
                                                options={contractFormPartieConfig.l_UNIDAD !== null ? contractFormPartieConfig.l_UNIDAD.map(item => { return  { key: item.id, text: item.title } }) : []}
                                                selectedKey={objContractPartie.iteM_PARTIDA.unidadPartidaId}
                                                onChange={handleSelectServiceUnit}
                                                checkable
                                                disabled={!objIsValidForm.canValidateIdMonedaPartida}
                                                styles={ {title: { height: "27px" }} }
                                                className="mb-1"
                                            />
                                            {
                                                objIsValidForm.canValidateUnidadPartida &&
                                                <div id='rfvddlUnidadPartida'>
                                                    <CValidator isInValid={objIsValidForm.isInvalidUnidadPartida} inValidText={t('data-lang-msg-required')} /> 
                                                </div>
                                            }
                                        </Col>
                                        <Col xs={12} xl={6} className="mt-1">
                                            <CLabel labelText={ t('data-lang-lbl-contractpartie-totalserviceamount') } />
                                            <JqxNumberInput
                                                max={999999999999999}
                                                maxLength="25"
                                                inputMode="advanced"
                                                height={25}
                                                width={"100%"}
                                                decimalDigits={numberValidDecimals}
                                                digits={19}
                                                symbolPosition={'right'}
                                                value={objContractPartie.iteM_PARTIDA.cantidadTotalServicio}
                                                //groupSeparator= '.'
                                                //decimalSeparator= ','
                                                onChange={(e) => onChangeObjPartieString(e, 'cantidadTotalServicio', 'isInValidCantidadTotalServicio')}
                                            />
                                            {
                                                objIsValidForm.canValidateCantidadTotalServicio &&
                                                <div id='rfvtxtCantidadTotal'>
                                                    <CValidator isInValid={objIsValidForm.isInValidCantidadTotalServicio} inValidText={t('data-lang-msg-required')} /> 
                                                </div>
                                            }
                                        </Col>
                                    </Row>
                                    <Row className='pt-1'>
                                        <Col xs={12} xl={6} className="mt-1">
                                            <CLabel labelText={ t('data-lang-lbl-contractpartie-prevserviceamount') } />
                                            <JqxNumberInput
                                                max={999999999999999}
                                                maxLength="25"
                                                inputMode="advanced"
                                                height={25}
                                                width={"100%"}
                                                decimalDigits={numberValidDecimals}
                                                digits={19}
                                                symbolPosition={'right'}
                                                value={objContractPartie.iteM_PARTIDA.cantidadPreviaServicio}
                                                //groupSeparator= '.'
                                                //decimalSeparator= ','
                                                disabled={!objIsValidForm.canValidateCantidadPreviaServicio}
                                                onChange={(e) => onChangeObjPartieString(e, 'cantidadPreviaServicio', 'isInValidCantidadPreviaServicio')}
                                            />
                                            {
                                                objIsValidForm.canValidateCantidadPreviaServicio &&
                                                <div id='rfvtxtCantidadPrevia'>
                                                    <CValidator isInValid={objIsValidForm.isInValidCantidadPreviaServicio} inValidText={t('data-lang-msg-required')} /> 
                                                </div>
                                            }
                                        </Col>
                                    </Row>
                                </div>
                            }
                            {
                                objIsValidForm.visible_divMontoTotal &&
                                <div id='divMontoTotal'>
                                    <Row className='pt-1'>
                                        {
                                            objIsValidForm.visible_divMontoTotal_Ps &&
                                            <Col id='divMontoTotal_Ps' xs={12} xl={6} className="mt-1">
                                                <CLabel labelText={ t('data-lang-lbl-contractpartie-totalamountsumalzps') } />
                                                <JqxNumberInput
                                                    max={999999999999999}
                                                    maxLength="25"
                                                    inputMode="advanced"
                                                    height={25}
                                                    width={"100%"}
                                                    decimalDigits={numberValidDecimals}
                                                    digits={19}
                                                    symbolPosition={'right'}
                                                    value={objContractPartie.iteM_PARTIDA.montoTotalSumaAlzadaPartida}
                                                    //groupSeparator= '.'
                                                    //decimalSeparator= ','
                                                    disabled={objContractPartie.iteM_PARTIDA.clasePartidaId !== enum__ENUM_CLASE_PARTIDA.PSP_SUMA_ALZADA}
                                                    onChange={(e) => onChangeObjPartieString(e, 'montoTotalSumaAlzadaPartida', 'isInvalidMontoTotalSumaAlzadaPartidaPs')}
                                                />
                                                {
                                                    objIsValidForm.canValidateMontoTotalSumaAlzadaPartidaPs && !objContractPartie.iteM_PARTIDA.clasePartidaId !== enum__ENUM_CLASE_PARTIDA.PSP_SUMA_ALZADA &&
                                                    <div id='rfvtxtPsSumaAlzada'>
                                                        <CValidator isInValid={objIsValidForm.isInvalidMontoTotalSumaAlzadaPartidaPs} inValidText={t('data-lang-msg-required')} /> 
                                                    </div>
                                                }
                                            </Col>
                                        }
                                        {
                                            objIsValidForm.visible_divMontoTotal_Pc &&
                                            <Col id='divMontoTotal_Pc' xs={12} xl={6} className="mt-1">
                                                <CLabel labelText={ t('data-lang-lbl-contractpartie-totalamountsumalzpc') } />
                                                <JqxNumberInput
                                                    max={999999999999999}
                                                    maxLength="25"
                                                    inputMode="advanced"
                                                    height={25}
                                                    width={"100%"}
                                                    decimalDigits={numberValidDecimals}
                                                    digits={19}
                                                    symbolPosition={'right'}
                                                    value={objContractPartie.iteM_PARTIDA.montoTotalSumaAlzadaPartida}
                                                    //groupSeparator= '.'
                                                    //decimalSeparator= ','
                                                    disabled={objContractPartie.iteM_PARTIDA.clasePartidaId !== enum__ENUM_CLASE_PARTIDA.PCI_SUMA_ALZADA}
                                                    onChange={(e) => onChangeObjPartieString(e, 'montoTotalSumaAlzadaPartida', 'isInvalidMontoTotalSumaAlzadaPartidaPc')}
                                                />
                                                {
                                                    objIsValidForm.canValidateMontoTotalSumaAlzadaPartidaPc && !objContractPartie.iteM_PARTIDA.clasePartidaId !== enum__ENUM_CLASE_PARTIDA.PCI_SUMA_ALZADA &&
                                                    <div id='rfvtxtPcSumaAlzada'>
                                                        <CValidator isInValid={objIsValidForm.isInvalidMontoTotalSumaAlzadaPartidaPc} inValidText={t('data-lang-msg-required')} /> 
                                                    </div>
                                                }
                                            </Col>
                                        }
                                    </Row>
                                </div>
                            }
                            {
                                objIsValidForm.visible_pnlPSPrecioUnitario &&
                                <Row id='pnlPSPrecioUnitario' className='pt-1'>
                                    <Col xs={12} xl={6} className="mt-1">
                                        <CLabel labelText={ t('data-lang-lbl-contractpartie-unitaryprice') } />
                                        <JqxNumberInput
                                            max={999999999999999}
                                            maxLength="25"
                                            inputMode="advanced"
                                            height={25}
                                            width={"100%"}
                                            decimalDigits={numberValidDecimals}
                                            digits={19}
                                            symbolPosition={'right'}
                                            value={objContractPartie.iteM_PARTIDA.precioUnitarioBasePartida}
                                            //groupSeparator= '.'
                                            //decimalSeparator= ','
                                            onChange={(e) => onChangeObjPartieString(e, 'precioUnitarioBasePartida','isInvalidPrecioUnitarioBasePartida')}
                                        />
                                        {
                                            objIsValidForm.canValidatePrecioUnitarioBasePartida &&
                                            <div id='rfvtxtPrecioUnitario'>
                                                <CValidator isInValid={objIsValidForm.isInvalidPrecioUnitarioBasePartida} inValidText={t('data-lang-msg-required')} /> 
                                            </div>
                                        }
                                    </Col>
                                </Row>
                            }
                            <Row className='pt-1'>
                                <Col xs={12} xl={6} className="mt-1">
                                    <CLabel labelText={ t('data-lang-lbl-internalcode') } />
                                    <JqxInput
                                        ref={refCodigoInterno}
                                        height={25}
                                        width={"100%"}
                                        value={!isNullUndefined(objContractPartie.iteM_PARTIDA.codigoInterno) ? objContractPartie.iteM_PARTIDA.codigoInterno : '' }
                                        onChange={(e) => onChangeObjPartieTextInputString(e, 'codigoInterno', 'isInValidCodigoInterno')}
                                    />
                                    <div>
                                        <CValidator isInValid={objIsValidForm.isInValidCodigoInterno} inValidText={t('data-lang-msg-lettersnumbersandhyphenunderscore')} /> 
                                    </div>
                                </Col>
                            </Row>
                            </div>
                        }
                        {
                            formView === enum_CONTACTPARTIE_PARTIE_FORM_VIEW.EDIT &&
                            <>
                                {
                                    (objContractPartie.iteM_PARTIDA.clasePartidaId !== enum__ENUM_CLASE_PARTIDA.PCI_CONSUMO_RECURSOS && objContractPartie.iteM_PARTIDA.clasePartidaId !== enum__ENUM_CLASE_PARTIDA.PSP_CONSUMO_RECURSOS) &&
                                    <div className='pt-4'>
                                        <div style={{borderBottom: "1px solid #999"}}><h5>{ t('data-lang-lbl-contractpartie-polynomyadjustment') }</h5></div>
                                        <Row className='pt-1'>
                                            <Col xs={12} xl={6}>
                                                <CLabel labelText={ t('data-lang-lbl-contractpartie-polynomyname') } />
                                                <Dropdown
                                                    placeholder={t('data-lang-lbl-contractpartie-polynomyname')}
                                                    options={contractFormPolynomyConfig.l_TIPO_POLINOMIO !== null ? contractFormPolynomyConfig.l_TIPO_POLINOMIO.map(item => { return  { key: item.id, text: item.title } }) : []}
                                                    selectedKey={objPolynomy.tipoPolinomioId}
                                                    onChange={handleSelectPolynomyType}
                                                    checkable
                                                    styles={ {title: { height: "27px" }} }
                                                    className="mb-1"
                                                />
                                                <CValidator isInValid={objIsValidPolynomyForm.isInvalidPolynomyType} isInvalidText={!objIsValidPolynomyForm.isInvalidPolynomyType ? "" : null} inValidText={t('data-lang-msg-required')} />
                                            </Col>
                                            <Col xs={12} xl={6} className="mt-1">
                                                <CLabel labelText={ t('data-lang-lbl-contractpartie-ponderator') } />
                                                <JqxNumberInput
                                                    max={100}
                                                    inputMode="simple"
                                                    width={80}
                                                    height={25}
                                                    symbolPosition={'right'}
                                                    symbol={'%'}
                                                    digits={3}
                                                    //groupSeparator= '.'
                                                    //decimalSeparator= ','
                                                    value={!isNullUndefined(objPolynomy.ponderador) ? objPolynomy.ponderador : 0}
                                                    onChange={(e) => onChangeObjPolynomyString(e, 'ponderador')}
                                                />
                                                <CValidator isInValid={objIsValidPolynomyForm.isInValidPonderador} isInvalidText={!objIsValidPolynomyForm.isInValidPonderador ? "" : null} inValidText={t('data-lang-msg-required-notzero')} />
                                            </Col>
                                        </Row>
                                        <Row className='pt-1'>
                                            <Col xs={12} xl={6} className="mt-1">
                                                <div>
                                                    <CLabel labelText={ t('data-lang-lbl-contractpartie-basedate') } />
                                                </div>
                                                <div>
                                                    <JqxInput
                                                        height={25}
                                                        width={"100%"}
                                                        value={objPolynomy.fechaBase}
                                                        onChange={(event) => onChangeObjPolynomyTextInputString(event, 'fechaBase')}
                                                    />
                                                </div>
                                                <div>
                                                    <JqxInput
                                                        height={25}
                                                        width={"100%"}
                                                        value={objPolynomy.valorBase}
                                                        onChange={(event) => onChangeObjPolynomyTextInputString(event, 'valorBase')}
                                                    />
                                                </div>
                                                <CValidator isInValid={objIsValidPolynomyForm.isInValidFechaBase} isInvalidText={!objIsValidPolynomyForm.isInValidFechaBase ? "" : null} inValidText={t('data-lang-msg-required')} />
                                                <div className='text-end'>
                                                    {
                                                        isNullUndefinedOrEmptyOrZero(objPolynomy.tipoPolinomioId) &&
                                                        <DefaultButton disable={true} text={t('data-lang-btn-basevalue')} />
                                                    }
                                                    {
                                                        !isNullUndefinedOrEmptyOrZero(objPolynomy.tipoPolinomioId) &&
                                                        <DefaultButton onClick={onSelectBaseDateDialog} text={t('data-lang-btn-basevalue')} />
                                                    }
                                                </div>
                                            </Col>
                                            <Col xs={12} xl={6} className="mt-1">
                                                <CLabel labelText={ t('data-lang-lbl-contractpartie-monthoffset') } />
                                                <Dropdown
                                                    placeholder={t('data-lang-lbl-contractpartie-monthoffset')}
                                                    options={contractFormPolynomyConfig.l_MESES_DESFASE !== null ? contractFormPolynomyConfig.l_MESES_DESFASE.map(item => { return  { key: item, text: item } }) : []}
                                                    selectedKey={objPolynomy.mesesDesfase}
                                                    onChange={handleSelectMonthDiff}
                                                    checkable
                                                    styles={ {title: { height: "27px" }} }
                                                    className="mb-1"
                                                />
                                                <CValidator isInValid={objIsValidPolynomyForm.isInvalidMonthOffset} isInvalidText={!objIsValidPolynomyForm.isInvalidMonthOffset ? "" : null} inValidText={t('data-lang-msg-required')} />
                                            </Col>
                                        </Row>
                                        <Row className='pt-1'>
                                            <Col xs={12} xl={6} className="mt-1">
                                                <CLabel labelText={ t('data-lang-lbl-contractpartie-adjustmentmonthfrecuency') } />
                                                <JqxNumberInput
                                                    inputMode="simple"
                                                    width={80}
                                                    height={25}
                                                    digits={3}
                                                    decimalDigits={0}
                                                    min={0}
                                                    max={999}    
                                                    value={!isNullUndefined(objPolynomy.periodicidadMeses) ? objPolynomy.periodicidadMeses : 0}
                                                    onChange={(e) => onChangeObjPolynomyString(e, 'periodicidadMeses')}
                                                />
                                                <CValidator isInValid={objIsValidPolynomyForm.isInValidPeriodicidadMeses} isInvalidText={!objIsValidPolynomyForm.isInValidPeriodicidadMeses ? "" : null} inValidText={t('data-lang-msg-required-notzero')} />
                                            </Col>
                                            <Col xs={12} xl={6} className="mt-1">
                                                <div>
                                                    <CLabel labelText={ t('data-lang-lbl-contractpartie-firstmonthapply') } />
                                                </div>
                                                <div>
                                                    <DatePicker
                                                        selected={ objPolynomy.primerMesReajuste } 
                                                        onChange={(date) => handlePolynomyDateChange(date, 'primerMesReajuste')}
                                                        height={25}
                                                        dateFormat="yyyy/MM"
                                                        showMonthYearPicker
                                                        showFullMonthYearPicker 
                                                        placeholderText={ t('data-lang-lbl-contractpartie-firstmonthapply') } 
                                                        className="form-control"
                                                        customInput={ <CalendarCustomInput icon={<Icon iconName='Calendar' />} /> }
                                                    />
                                                    <CValidator isInValid={objIsValidPolynomyForm.isInValidPrimerMesReajuste} isInvalidText={!objIsValidPolynomyForm.isInValidPrimerMesReajuste ? "" : null} inValidText={t('data-lang-msg-required')} />
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col className='text-end'>
                                                <PrimaryButton onClick={ handleSavePolynomy }>{ t('data-lang-btn-save') }</PrimaryButton>
                                            </Col>
                                        </Row>
                                        <Row className='pt-2'>
                                            <Col>
                                                <Card className='border'>
                                                    <Card.Body>
                                                        <Row>
                                                        {
                                                            objContractPartie.l_POLINOMIO && objContractPartie.l_POLINOMIO.map((polynomy, index) => (
                                                                <Col key={polynomy.id} xl={6}>
                                                                    <TablePolynomyItem
                                                                        parentPolinomyType={enum_CONTRACTPARTIE_PARENT_PONINOMY_TYPE.PARTIE}
                                                                        parentId={objContractPartie.iteM_PARTIDA.id}
                                                                        tableItem={polynomy}
                                                                        polynomyViewType={enum_CONTACTPARTIE_POLINOMY_FORM_VIEW.COMPLEX_EDIT}
                                                                        addCardWidth={false}
                                                                        handleDeletePolynomyClickAux={handleDeletePolynomyClick}
                                                                        setTotalRestAdjustmentAmount={setTotalRestAdjustmentAmount}
                                                                        l_POLINOMIO={objContractPartie.l_POLINOMIO}
                                                                    />
                                                                </Col>
                                                            ))
                                                        }
                                                        {
                                                            totalRestAdjustmentAmount > 0 &&
                                                            <TablePolynomyItemNotAdjustment totalRestAdjustmentAmount={totalRestAdjustmentAmount} addCardWidth={false} />
                                                        }
                                                        </Row>
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                        </Row>
                                    </div>
                                }
                            </>
                        }
                            
                    </fieldset>
                }
                {
                    isDialogOpen &&
                    <SidePanelBaseDateContractPartie
                        inputParam_IsDialogOpen={isDialogOpen}
                        inputParam_SetIsDialogOpen={setIsDialogOpen}
                        inputParam_SetSelectedBaseValue={handleSetPolynomyBaseDate}
                        inputParam_NemoIndicator={objPolynomy.tipoPolinomioTitle}
                        inputParam_StartDate={objContractPartie.iteM_PARTIDA.mesInicioPartida}
                    />
                }
            </Panel>
        </div>
    );
};

SidePanelInsertEditContractPartie.propTypes = {
    elementId: PropTypes.number.isRequired,
};

export default SidePanelInsertEditContractPartie;